import CONSTANTS from "../Constants/Constants";
import { returnAirportInfoByIATACode } from "../helpers/AutoCompleteInit";
import { getCountryCode } from "../helpers/country_calling_codes";

const return_slices = async (data, dictionary={}) => {

    const {
        travelerPricings,
        validatingAirlineCodes,
    } = data;

    const {
        aircraft={},
        carriers={},
        currencies={},
        locations={},
    } = dictionary;

    let _itineraries=[];
    
    for(let i=0; i<data?.itineraries?.length; i++){

        const _itin_data = data?.itineraries?.[i];
        const _itin_segments = _itin_data?.segments;
        const _fist_seg = _itin_segments?.[0];
        const _last_set = _itin_segments?.[(_itin_segments?.length-1)];
        
        let d_airport = await returnAirportInfoByIATACode(_fist_seg?.departure?.iataCode);
        if(!d_airport){
            d_airport = {name: "", city: "", country: "", IATA: "", ICAO: "", lat: "", lon: "", timezone: ""} // default values
        }
        const {
            name: d_name, 
            city: d_city,
            country: d_country, 
            IATA: d_IATA, 
            ICAO: d_ICAO, 
            lat: d_lat, 
            lon: d_lon, 
            timezone: d_timezone,
        } = d_airport;

        let _airport = await returnAirportInfoByIATACode(_last_set?.arrival?.iataCode);
        if(!_airport){
            _airport = {name: "", city: "", country: "", IATA: "", ICAO: "", lat: "", lon: "", timezone: ""} // default values
        }
        const {
            name: _name, 
            city: _city,
            country: _country, 
            IATA: _IATA, 
            ICAO: _ICAO, 
            lat: _lat, 
            lon: _lon, 
            timezone: _timezone,
        } = _airport;
        
        const {
            duration,
        } = _itin_data;

        let __itin_obj = {
            id: "",
            comparison_key: "",
            ngs_shelf: 1,
            destination_type: "airport",
            origin_type: "airport",
            fare_brand_name: "Basic",
            segments: [],
            conditions: {
                priority_check_in: null,
                priority_boarding: null,
                advance_seat_selection: null,
                change_before_departure: {
                    penalty_currency: "",
                    penalty_amount: "",
                    allowed: true
                }
            },
            duration: duration,
            destination: {
                id: "",
                airports: null,
                iata_city_code: "",
                city_name: _city,
                iata_country_code: "", //_country
                icao_code: _ICAO,
                iata_code: _last_set?.arrival?.iataCode,
                latitude: _lat,
                longitude: _lon,
                city: {
                    iata_city_code: "",
                    city_name: _city,
                    iata_country_code: "",
                    icao_code: null,
                    iata_code: "",
                    latitude: null,
                    longitude: null,
                    time_zone: _timezone,
                    type: "city",
                    name: _city,
                    id: ""
                },
                time_zone: _timezone,
                type: "airport",
                name: _name,
            },
            origin: {
                id: "",
                airports: null,
                iata_city_code: "",
                city_name: d_city,
                iata_country_code: "", //_country
                icao_code: d_ICAO,
                iata_code: _fist_seg?.departure?.iataCode,
                latitude: d_lat,
                longitude: d_lon,
                city: {
                    id: "",
                    iata_city_code: "",
                    city_name: d_city,
                    iata_country_code: "",
                    icao_code: null,
                    iata_code: "",
                    latitude: null,
                    longitude: null,
                    time_zone: d_timezone,
                    type: "city",
                    name: d_city,
                },
                time_zone: d_timezone,
                type: "airport",
                name: d_name,
            },
        }

        let _segments = [];
        for(let j=0; j<_itin_segments?.length; j++){

            const _seg_data = _itin_segments?.[j];

            /*{
                "departure": {
                    "iataCode": "ACC",
                    "terminal": "3",
                    "at": "2025-09-19T06:05:00"
                },
                "arrival": {
                    "iataCode": "CMN",
                    "terminal": "2",
                    "at": "2025-09-19T11:30:00"
                },
                "carrierCode": "AT",
                "number": "514",
                "aircraft": {
                    "code": "73H"
                },
                "operating": {
                    "carrierCode": "AT"
                },
                "duration": "PT4H25M",
                "id": "81",
                "numberOfStops": 0,
                "blacklistedInEU": false
            }*/

            let d_s_airport = await returnAirportInfoByIATACode(_seg_data?.departure?.iataCode);
            if(!d_s_airport){
                d_s_airport = {name: "", city: "", country: "", IATA: "", ICAO: "", lat: "", lon: "", timezone: ""} // default values
            }
            const {
                name: d_s_name, 
                city: d_s_city,
                country: d_s_country, 
                IATA: d_s_IATA, 
                ICAO: d_s_ICAO, 
                lat: d_s_lat, 
                lon: d_s_lon, 
                timezone: d_s_timezone,
            } = d_s_airport;

            let s_airport = await returnAirportInfoByIATACode(_seg_data?.arrival?.iataCode);
            if(!s_airport){
                s_airport = {name: "", city: "", country: "", IATA: "", ICAO: "", lat: "", lon: "", timezone: ""} // default values
            }
            const {
                name: s_name, 
                city: s_city,
                country: s_country, 
                IATA: s_IATA, 
                ICAO: s_ICAO, 
                lat: s_lat, 
                lon: s_lon, 
                timezone: s_timezone,
            } = s_airport;

            let __passengers = [];
            for(let psng=0; psng<travelerPricings?.length; psng++){

                const _tps = travelerPricings[psng];

                const {
                    fareDetailsBySegment,
                } = _tps;

                let _cabin_class_marketing_name="";
                let _fare_basis_code="";
                let _cabin_class="";
                let _baggages=[];
                let _amenities={};
                for(let w=0; w<fareDetailsBySegment?.length; w++){
                    let _ssegment = fareDetailsBySegment[w];
                    if(_ssegment?.segmentId===_seg_data?.id){
                        const {
                            amenities=[]
                        } = _ssegment;

                        _cabin_class=_ssegment?.cabin;
                        _cabin_class_marketing_name=_ssegment?.cabin;
                        _fare_basis_code=_ssegment?.fareBasis;

                        if(_ssegment?.includedCheckedBags){
                            _baggages.push({
                                quantity: _ssegment?.includedCheckedBags?.quantity,
                                type: "checked"
                            });
                        }

                        if(_ssegment?.includedCabinBags){
                            _baggages.push({
                                quantity: _ssegment?.includedCabinBags?.quantity,
                                type: "carry_on"
                            });
                        }

                        for(let aa=0; aa<amenities.length; aa++){
                            let amenity = amenities[aa];
                            if(amenity?.amenityType==="BAGGAGE"){
                                _amenities.baggage = {
                                    available: true,
                                    ...amenity
                                }
                            }else if(amenity?.amenityType==="PRE_RESERVED_SEAT"){
                                _amenities.seat = {
                                    available: true,
                                    pitch: "n/a",
                                    legroom: "n/a",
                                    type: null,
                                    ...amenity
                                }
                            }else if(amenity?.amenityType==="MEAL"){
                                _amenities.meal = {
                                    available: true,
                                    ...amenity
                                }
                            }else if(amenity?.amenityType==="WIFI"){
                                _amenities.wifi = {
                                    available: true,
                                    cost: "n/a",
                                    ...amenity
                                }
                            }else if(amenity?.amenityType==="power"){
                                _amenities.power = {
                                    available: true,
                                    ...amenity
                                }
                            }
                            
                        }
                    }
                }

                /*{
            "travelerId": "1",
            "fareOption": "STANDARD",
            "travelerType": "ADULT",
            "price": {
                "currency": "USD",
                "total": "388.60",
                "base": "75.00"
            },
            "fareDetailsBySegment": [
                {
                    "segmentId": "70",
                    "cabin": "ECONOMY",
                    "fareBasis": "RA0WAAFA",
                    "brandedFare": "CLASSIC",
                    "brandedFareLabel": "CLASSIC",
                    "class": "R",
                    "includedCheckedBags": {
                        "quantity": 2
                    },
                    "includedCabinBags": {
                        "quantity": 1
                    },
                    "amenities": [
                        {
                            "description": "CHECKED BAG THIRD",
                            "isChargeable": true,
                            "amenityType": "BAGGAGE",
                            "amenityProvider": {
                                "name": "BrandedFare"
                            }
                        },
                        {
                            "description": "PRE RESERVATION SEAT ASSIGNMEN",
                            "isChargeable": true,
                            "amenityType": "PRE_RESERVED_SEAT",
                            "amenityProvider": {
                                "name": "BrandedFare"
                            }
                        },
                        {
                            "description": "MEAL BEVERAGE",
                            "isChargeable": false,
                            "amenityType": "MEAL",
                            "amenityProvider": {
                                "name": "BrandedFare"
                            }
                        },
                        {
                            "description": "100 PERCENT MILES",
                            "isChargeable": false,
                            "amenityType": "BRANDED_FARES",
                            "amenityProvider": {
                                "name": "BrandedFare"
                            }
                        },
                        {
                            "description": "CHANGE BEFORE DEPARTURE",
                            "isChargeable": true,
                            "amenityType": "BRANDED_FARES",
                            "amenityProvider": {
                                "name": "BrandedFare"
                            }
                        },
                        {
                            "description": "CHANGE AFTER DEPARTURE",
                            "isChargeable": true,
                            "amenityType": "BRANDED_FARES",
                            "amenityProvider": {
                                "name": "BrandedFare"
                            }
                        }
                    ]
                }
            ]
        }*/
                __passengers.push({
                    passenger_id: "",
                    cabin: {
                        amenities: _amenities,
                        marketing_name: _cabin_class_marketing_name,
                        name: _cabin_class
                    },
                    baggages: _baggages,
                    cabin_class_marketing_name: _cabin_class_marketing_name,
                    fare_basis_code: _fare_basis_code,
                    cabin_class: _cabin_class
                });
            }

            _segments.push({
                id: _seg_data?.id,
                origin_terminal: "",
                destination_terminal: "",
                aircraft: null,
                departing_at: _seg_data?.departure?.at,
                arriving_at: _seg_data?.arrival?.at,
                operating_carrier: {
                    id: "",
                    logo_symbol_url: `https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/${_seg_data?.operating?.carrierCode}.svg`,
                    logo_lockup_url: `https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/${_seg_data?.operating?.carrierCode}.svg`,
                    conditions_of_carriage_url: `https://www.britishairways.com/en-gb/information/legal/british-airways/general-conditions-of-carriage`,
                    iata_code: _seg_data?.operating?.carrierCode,
                    name: (carriers?.[_seg_data?.operating?.carrierCode] || ""),
                },
                marketing_carrier: {
                    id: "",
                    logo_symbol_url: `https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/${_seg_data?.carrierCode}.svg`,
                    logo_lockup_url: `https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/${_seg_data?.carrierCode}.svg`,
                    conditions_of_carriage_url: `https://www.britishairways.com/en-gb/information/legal/british-airways/general-conditions-of-carriage`,
                    iata_code: _seg_data?.carrierCode,
                    name: (carriers?.[_seg_data?.carrierCode] || ""),
                },
                stops: [],
                operating_carrier_flight_number: "",
                marketing_carrier_flight_number: "",
                distance: "",
                passengers: __passengers,
                duration: _seg_data?.duration,
                destination: {
                    id: "",
                    airports: null,
                    iata_city_code: "",
                    city_name: s_city,
                    iata_country_code: "", //s_country
                    icao_code: s_ICAO,
                    iata_code: _seg_data?.arrival?.iataCode,
                    latitude: s_lat,
                    longitude: s_lon,
                    city: {
                        id: "",
                        iata_city_code: "",
                        city_name: s_city,
                        iata_country_code: "",
                        icao_code: null,
                        iata_code: "",
                        latitude: null,
                        longitude: null,
                        time_zone: null,
                        type: "city",
                        name: s_city,
                    },
                    time_zone: s_timezone,
                    type: "airport",
                    name: s_name,
                },
                origin: {
                    id: "",
                    airports: null,
                    iata_city_code: "",
                    city_name: d_s_city,
                    iata_country_code: "", //d_s_country
                    icao_code: d_s_ICAO,
                    iata_code: _seg_data?.departure?.iataCode,
                    latitude: d_s_lat,
                    longitude: d_s_lon,
                    city: {
                        id: "",
                        iata_city_code: "",
                        city_name: d_s_city,
                        iata_country_code: "",
                        icao_code: null,
                        iata_code: "",
                        latitude: null,
                        longitude: null,
                        time_zone: null,
                        type: "city",
                        name: d_s_city,
                    },
                    time_zone: d_s_timezone,
                    type: "airport",
                    name: d_s_name,   
                },  
            });

        }

        __itin_obj.segments=_segments;
        _itineraries?.push(__itin_obj)
        
    }

    //console.log("ITINERARIES", _itineraries);

    return _itineraries;

    /*{    
        "segments": [
            {
                "departure": {
                    "iataCode": "ACC",
                    "terminal": "3",
                    "at": "2025-09-19T06:05:00"
                },
                "arrival": {
                    "iataCode": "CMN",
                    "terminal": "2",
                    "at": "2025-09-19T11:30:00"
                },
                "carrierCode": "AT",
                "number": "514",
                "aircraft": {
                    "code": "73H"
                },
                "operating": {
                    "carrierCode": "AT"
                },
                "duration": "PT4H25M",
                "id": "81",
                "numberOfStops": 0,
                "blacklistedInEU": false
            },
            {
                "departure": {
                    "iataCode": "CMN",
                    "terminal": "1",
                    "at": "2025-09-19T13:40:00"
                },
                "arrival": {
                    "iataCode": "LHR",
                    "terminal": "4",
                    "at": "2025-09-19T16:50:00"
                },
                "carrierCode": "AT",
                "number": "800",
                "aircraft": {
                    "code": "7M8"
                },
                "operating": {
                    "carrierCode": "AT"
                },
                "duration": "PT3H10M",
                "id": "82",
                "numberOfStops": 0,
                "blacklistedInEU": false
            }
        ]
    }*/
}

const return_adapted_slices_of_completed_amadeus_flight_order = async (data, dictionary={}) => {

    const {
        flightOffers,
    } = data;

    const {
        itineraries,
        travelerPricings,
    } = flightOffers[0];

    let _slices = [];

    for(let i=0; i<itineraries?.length; i++){
        let _itin=itineraries?.[i];

        const {
            duration,
            segments,
        } = _itin;

        const adapted_segments = [];

        const segment_from_origin = _itin?.segments?.[0];
        const segment_to_destination = _itin?.segments?.[(_itin?.segments?.length-1)];
        let dep_airport = await returnAirportInfoByIATACode(segment_from_origin?.departure?.iataCode);
        if(!dep_airport){
            dep_airport = {name: "", city: "", country: "", IATA: "", ICAO: "", lat: "", lon: "", timezone: ""} // default values
        }
        const {
            name: dep_name, 
            city: dep_city,
            country: dep_country, 
            IATA: dep_IATA, 
            ICAO: dep_ICAO, 
            lat: dep_lat, 
            lon: dep_lon, 
            timezone: dep_timezone,
        } = dep_airport;

        let dest_airport = await returnAirportInfoByIATACode(segment_to_destination?.arrival?.iataCode);
        if(!dest_airport){
            dest_airport = {name: "", city: "", country: "", IATA: "", ICAO: "", lat: "", lon: "", timezone: ""} // default values
        }
        const {
            name: dest_name, 
            city: dest_city,
            country: dest_country, 
            IATA: dest_IATA, 
            ICAO: dest_ICAO, 
            lat: dest_lat, 
            lon: dest_lon, 
            timezone: dest_timezone,
        } = dest_airport;

        for(let j=0; j<segments?.length; j++){

            const _seg_data = segments[j];

            /*const _seg_passengers = [
                {
                    passenger_id: "",
                    seat: null,
                    cabin_class_marketing_name: "Economy",
                    cabin_class: "economy",
                    baggages: [
                        {
                            type: "checked",
                            quantity: 1
                        },
                        {
                            type: "carry_on",
                            quantity: 1
                        }
                    ]
                }
            ]*/
            let origin_airport = await returnAirportInfoByIATACode(_seg_data?.departure?.iataCode);
            if(!origin_airport){
                origin_airport = {name: "", city: "", country: "", IATA: "", ICAO: "", lat: "", lon: "", timezone: ""} // default values
            }
            const {
                name: origin_name, 
                city: origin_city,
                country: origin_country, 
                IATA: origin_IATA, 
                ICAO: origin_ICAO, 
                lat: origin_lat, 
                lon: origin_lon, 
                timezone: origin_timezone,
            } = origin_airport;

            let destination_airport = await returnAirportInfoByIATACode(_seg_data?.arrival?.iataCode);
            if(!destination_airport){
                destination_airport = {name: "", city: "", country: "", IATA: "", ICAO: "", lat: "", lon: "", timezone: ""} // default values
            }
            const {
                name: destination_name, 
                city: destination_city,
                country: destination_country, 
                IATA: destination_IATA, 
                ICAO: destination_ICAO, 
                lat: destination_lat, 
                lon: destination_lon, 
                timezone: destination_timezone,
            } = destination_airport;

            let __passengers = [];
            for(let psng=0; psng<travelerPricings?.length; psng++){

                const _tps = travelerPricings[psng];

                const {
                    fareDetailsBySegment,
                } = _tps;

                let _cabin_class_marketing_name="";
                let _fare_basis_code="";
                let _cabin_class="";
                let _baggages=[];
                let _amenities={};
                for(let w=0; w<fareDetailsBySegment?.length; w++){
                    let _ssegment = fareDetailsBySegment[w];
                    if(_ssegment?.segmentId===_seg_data?.id){
                        const {
                            amenities=[]
                        } = _ssegment;

                        _cabin_class=_ssegment?.cabin;
                        _cabin_class_marketing_name=_ssegment?.cabin;
                        _fare_basis_code=_ssegment?.fareBasis;

                        if(_ssegment?.includedCheckedBags){
                            _baggages.push({
                                quantity: _ssegment?.includedCheckedBags?.quantity,
                                type: "checked"
                            });
                        }

                        if(_ssegment?.includedCabinBags){
                            _baggages.push({
                                quantity: _ssegment?.includedCabinBags?.quantity,
                                type: "carry_on"
                            });
                        }

                        for(let aa=0; aa<amenities.length; aa++){
                            let amenity = amenities[aa];
                            if(amenity?.amenityType==="BAGGAGE"){
                                _amenities.baggage = {
                                    available: true,
                                    ...amenity
                                }
                            }else if(amenity?.amenityType==="PRE_RESERVED_SEAT"){
                                _amenities.seat = {
                                    available: true,
                                    pitch: "n/a",
                                    legroom: "n/a",
                                    type: null,
                                    ...amenity
                                }
                            }else if(amenity?.amenityType==="MEAL"){
                                _amenities.meal = {
                                    available: true,
                                    ...amenity
                                }
                            }else if(amenity?.amenityType==="WIFI"){
                                _amenities.wifi = {
                                    available: true,
                                    cost: "n/a",
                                    ...amenity
                                }
                            }else if(amenity?.amenityType==="power"){
                                _amenities.power = {
                                    available: true,
                                    ...amenity
                                }
                            }
                            
                        }
                    }
                }

                __passengers.push({
                    passenger_id: "",
                    seat: "",
                    cabin: {
                        amenities: _amenities,
                        marketing_name: _cabin_class_marketing_name,
                        name: _cabin_class
                    },
                    baggages: _baggages,
                    cabin_class_marketing_name: _cabin_class_marketing_name,
                    fare_basis_code: _fare_basis_code,
                    cabin_class: _cabin_class
                });
            }

            adapted_segments.push({
                id: _seg_data?.id,
                passengers: __passengers,
                origin_terminal: "",
                origin: {
                    id: "",
                    type: "airport",
                    time_zone: origin_timezone,
                    name: origin_name,
                    longitude: origin_lon,
                    latitude: origin_lat,
                    icao_code: origin_ICAO,
                    iata_country_code: "", // "GH"
                    iata_code: origin_IATA, //
                    iata_city_code: "", // "ACC"
                    city_name: origin_city,
                    city: {
                        id: "",
                        type: "city",
                        time_zone: "",
                        name: origin_city,
                        longitude: "",
                        latitude: "",
                        icao_code: "",
                        iata_country_code: "",
                        iata_code: "",
                        iata_city_code: "",
                        city_name: origin_city
                    }
                },
                operating_carrier_flight_number: "",
                operating_carrier: {
                    id: "",
                    name: "",
                    logo_symbol_url: `https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/${_seg_data?.operating?.carrierCode}.svg`,
                    logo_lockup_url: `https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/${_seg_data?.operating?.carrierCode}.svg`,
                    iata_code: _seg_data?.operating?.carrierCode,
                    conditions_of_carriage_url: "https://www.aa.com/i18n/customer-service/support/conditions-of-carriage.jsp"
                },
                marketing_carrier_flight_number: "",
                marketing_carrier: {
                    id: "",
                    name: "",
                    logo_symbol_url: `https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/${_seg_data?.carrierCode}.svg`,
                    logo_lockup_url: `https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/${_seg_data?.carrierCode}.svg`,
                    iata_code: _seg_data?.carrierCode,
                    conditions_of_carriage_url: "https://www.aa.com/i18n/customer-service/support/conditions-of-carriage.jsp"
                },
                duration: _seg_data?.duration,
                distance: "",
                destination_terminal: "",
                destination: {
                    id: "",
                    type: "airport",
                    time_zone: destination_timezone,
                    name: destination_name,
                    longitude: destination_lon,
                    latitude: destination_lat,
                    icao_code: destination_ICAO,
                    iata_country_code: "", // "US"
                    iata_code: destination_IATA,
                    iata_city_code: "", // "NYC"
                    city_name: destination_city, // ""
                    city: {
                        id: "",
                        type: "city",
                        time_zone: null,
                        name: destination_city,
                        longitude: "",
                        latitude: "",
                        icao_code: "",
                        iata_country_code: "",
                        iata_code: "",
                        iata_city_code: "",
                        city_name: destination_city
                    }
                },
                departure_terminal: "",
                departure_datetime: _seg_data?.departure?.at,
                departing_at: _seg_data?.departure?.at,
                arriving_at: _seg_data?.arrival?.at,
                arrival_terminal: "",
                arrival_datetime: _seg_data?.arrival?.at,
                aircraft: {
                    id: "",
                    name: "",
                    iata_code: ""
                }
            });
        }

        _slices?.push({
            id: "",
            segments: adapted_segments,
            origin_type: "airport",
            origin: {
                id: segment_from_origin?.id,
                type: "airport",
                time_zone: dep_timezone,
                name: dep_name,
                longitude: dep_lon,
                latitude: dep_lat,
                icao_code: dep_ICAO,
                iata_country_code: "", // dep_country
                iata_code: dep_IATA,
                iata_city_code: "", // "ACC"
                city_name: dep_city,
                city: {
                    id: "",
                    type: "city",
                    time_zone: dep_timezone,
                    name: dep_city,
                    longitude: "",
                    latitude: "",
                    icao_code: "",
                    iata_country_code: "",
                    iata_code: "",
                    iata_city_code: "",
                    city_name: dep_city
                },
            },
            fare_brand_name: "", // "Basic"
            duration,
            destination_type: "airport",
            destination: {
                "id": segment_to_destination?.id,
                "type": "airport",
                "time_zone": dest_timezone,
                "name": dest_name,
                "longitude": dest_lon,
                "latitude": dest_lat,
                "icao_code": dest_ICAO,
                "iata_country_code": "", // dest_country
                "iata_code": dest_IATA,
                "iata_city_code": "",
                "city_name": dest_city,
                "city": {
                    "id": "",
                    "type": "city",
                    "time_zone": "",
                    "name": dest_city,
                    "longitude": "",
                    "latitude": "",
                    "icao_code": "",
                    "iata_country_code": "",
                    "iata_code": "",
                    "iata_city_code": "",
                    "city_name": dest_city
                }
            },
            conditions: {
                change_before_departure: {
                    penalty_currency: null,
                    penalty_amount: null,
                    allowed: false
                }
            },
            changeable: false, // true
        });
    }

    return _slices;

    // Model Examples

    // Input ----------------------------------
    /*itineraries: [
        {
            "duration": "PT2H",
            "segments": [
                {
                    "id": "1",
                    "duration": "PT2H",
                    "aircraft": {
                        "code": "320"
                    },
                    "numberOfStops": 0,
                    "blacklistedInEU": false,
                    "carrierCode": "IB",
                    "operating": {
                        "carrierCode": "IB"
                    },
                    "number": "3403",
                    "departure": {
                        "at": "2018-09-22T10:15:00",
                        "terminal": "W",
                        "iataCode": "ORY"
                    },
                    "arrival": {
                        "at": "2018-09-22T12:15:00",
                        "terminal": "4",
                        "iataCode": "MAD"
                    },
                    "co2Emissions": [
                        {
                            "weight": "100",
                            "weightUnit": "KG",
                            "cabin": "ECONOMY"
                        }
                    ]
                }
            ]
        },
        {
            "duration": "PT1H20M",
            "segments": [
                {
                    "id": "20",
                    "duration": "PT1H20M",
                    "aircraft": {
                        "code": "320"
                    },
                    "numberOfStops": 0,
                    "blacklistedInEU": false,
                    "carrierCode": "IB",
                    "operating": {
                        "carrierCode": "IB"
                    },
                    "number": "3118",
                    "departure": {
                        "at": "2018-09-26T23:05:00",
                        "terminal": "4",
                        "iataCode": "MAD"
                    },
                    "arrival": {
                        "at": "2018-09-26T23:25:00",
                        "terminal": "1",
                        "iataCode": "LIS"
                    },
                    "co2Emissions": [
                        {
                            "weight": "100",
                            "weightUnit": "KG",
                            "cabin": "ECONOMY"
                        }
                    ]
                }
            ]
        },
        {
            "duration": "PT4H30M",
            "segments": [
                {
                    "id": "30",
                    "duration": "PT2H",
                    "aircraft": {
                        "code": "320"
                    },
                    "numberOfStops": 0,
                    "blacklistedInEU": false,
                    "carrierCode": "IB",
                    "operating": {
                        "carrierCode": "IB"
                    },
                    "number": "3109",
                    "departure": {
                        "at": "2018-10-04T12:35:00",
                        "terminal": "1",
                        "iataCode": "LIS"
                    },
                    "arrival": {
                        "at": "2018-10-04T14:55:00",
                        "terminal": "4",
                        "iataCode": "MAD"
                    },
                    "co2Emissions": [
                        {
                            "weight": "100",
                            "weightUnit": "KG",
                            "cabin": "ECONOMY"
                        }
                    ]
                },
                {
                    "id": "31",
                    "duration": "PT2H30M",
                    "aircraft": {
                        "code": "320"
                    },
                    "numberOfStops": 0,
                    "blacklistedInEU": false,
                    "carrierCode": "IB",
                    "operating": {
                        "carrierCode": "IB"
                    },
                    "number": "3444",
                    "departure": {
                        "at": "2018-10-04T16:05:00",
                        "terminal": "4",
                        "iataCode": "MAD"
                    },
                    "arrival": {
                        "at": "2018-10-04T18:05:00",
                        "terminal": "W",
                        "iataCode": "ORY"
                    },
                    "co2Emissions": [
                        {
                            "weight": "100",
                            "weightUnit": "KG",
                            "cabin": "ECONOMY"
                        }
                    ]
                }
            ]
        }
    ]*/

    // Output ---------------------------------
    /*[
        {
            "segments": [
                {
                    "passengers": [
                        {
                            "seat": null,
                            "passenger_id": "pas_0000Ac6K7OtiPbsp1NTVxK",
                            "cabin_class_marketing_name": "Economy",
                            "cabin_class": "economy",
                            "baggages": [
                                {
                                    "type": "checked",
                                    "quantity": 1
                                },
                                {
                                    "type": "carry_on",
                                    "quantity": 1
                                }
                            ]
                        }
                    ],
                    "origin_terminal": "2",
                    "origin": {
                        "type": "airport",
                        "time_zone": "Africa/Accra",
                        "name": "Kotoka International Airport",
                        "longitude": -0.167454,
                        "latitude": 5.605642,
                        "id": "arp_acc_gh",
                        "icao_code": "DGAA",
                        "iata_country_code": "GH",
                        "iata_code": "ACC",
                        "iata_city_code": "ACC",
                        "city_name": "Accra",
                        "city": null
                    },
                    "operating_carrier_flight_number": "10",
                    "operating_carrier": {
                        "name": "American Airlines",
                        "logo_symbol_url": "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/AA.svg",
                        "logo_lockup_url": "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/AA.svg",
                        "id": "arl_00009VME7DAGiJjwomhv32",
                        "iata_code": "AA",
                        "conditions_of_carriage_url": "https://www.aa.com/i18n/customer-service/support/conditions-of-carriage.jsp"
                    },
                    "marketing_carrier_flight_number": "10",
                    "marketing_carrier": {
                        "name": "American Airlines",
                        "logo_symbol_url": "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/AA.svg",
                        "logo_lockup_url": "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/AA.svg",
                        "id": "arl_00009VME7DAGiJjwomhv32",
                        "iata_code": "AA",
                        "conditions_of_carriage_url": "https://www.aa.com/i18n/customer-service/support/conditions-of-carriage.jsp"
                    },
                    "id": "seg_0000Ac6K7P3dohp5WA7RQW",
                    "duration": "PT11H32M",
                    "distance": "8221.392679809798",
                    "destination_terminal": "1",
                    "destination": {
                        "type": "airport",
                        "time_zone": "America/New_York",
                        "name": "John F. Kennedy International Airport",
                        "longitude": -73.778519,
                        "latitude": 40.640556,
                        "id": "arp_jfk_us",
                        "icao_code": "KJFK",
                        "iata_country_code": "US",
                        "iata_code": "JFK",
                        "iata_city_code": "NYC",
                        "city_name": "New York",
                        "city": {
                            "type": "city",
                            "time_zone": null,
                            "name": "New York",
                            "longitude": null,
                            "latitude": null,
                            "id": "cit_nyc_us",
                            "icao_code": null,
                            "iata_country_code": "US",
                            "iata_code": "NYC",
                            "iata_city_code": "NYC",
                            "city_name": null
                        }
                    },
                    "departure_terminal": "2",
                    "departure_datetime": "2023-11-29T21:40:00",
                    "departing_at": "2023-11-29T21:40:00",
                    "arriving_at": "2023-11-30T04:12:00",
                    "arrival_terminal": "1",
                    "arrival_datetime": "2023-11-30T04:12:00",
                    "aircraft": {
                        "name": "Airbus A319",
                        "id": "arc_00009VMF8AgpV5sdO0xXAn",
                        "iata_code": "319"
                    }
                }
            ],
            "origin_type": "airport",
            "origin": {
                "type": "airport",
                "time_zone": "Africa/Accra",
                "name": "Kotoka International Airport",
                "longitude": -0.167454,
                "latitude": 5.605642,
                "id": "arp_acc_gh",
                "icao_code": "DGAA",
                "iata_country_code": "GH",
                "iata_code": "ACC",
                "iata_city_code": "ACC",
                "city_name": "Accra",
                "city": null
            },
            "id": "sli_0000Ac6KEffjaAdhv9NCr2",
            "fare_brand_name": "Basic",
            "duration": "PT11H32M",
            "destination_type": "airport",
            "destination": {
                "type": "airport",
                "time_zone": "America/New_York",
                "name": "John F. Kennedy International Airport",
                "longitude": -73.778519,
                "latitude": 40.640556,
                "id": "arp_jfk_us",
                "icao_code": "KJFK",
                "iata_country_code": "US",
                "iata_code": "JFK",
                "iata_city_code": "NYC",
                "city_name": "New York",
                "city": {
                    "type": "city",
                    "time_zone": null,
                    "name": "New York",
                    "longitude": null,
                    "latitude": null,
                    "id": "cit_nyc_us",
                    "icao_code": null,
                    "iata_country_code": "US",
                    "iata_code": "NYC",
                    "iata_city_code": "NYC",
                    "city_name": null
                }
            },
            "conditions": {
                "change_before_departure": {
                    "penalty_currency": null,
                    "penalty_amount": null,
                    "allowed": false
                }
            },
            "changeable": true
        }
    ]*/
}

const return_passengers = (data, dictionary, ) => {

    const {
        travelerPricings,
    } = data;

    let _passengers = [];
    for(let i=0; i<travelerPricings?.length; i++) {
        let _traveler = travelerPricings[i];
        _passengers.push({
            id: _traveler?.travelerId,
            loyalty_programme_accounts: [],
            family_name: null,
            given_name: null,
            age: null,
            type: _traveler?.travelerType?.toLowerCase(),
        });
    }

    return _passengers;
}

const return_adapted_passengers_of_completed_amadeus_flight_order = async (data, dictionary={}) => {
    const {
        travelers,
    } = data;

    const _passengers = [];
    for(let psg=0; psg<travelers?.length; psg++){
        let current_passenger = psg<travelers?.[psg];

        const {
            id,
            dateOfBirth,
            name,
            contact,
            documents,
        } = current_passenger;

        _passengers?.push({
            id,
            type: "",
            title: "",
            phone_number: (contact?.phones?.[0]?.countryCallingCode+contact?.phones?.[0]?.number),
            loyalty_programme_accounts: [],
            infant_passenger_id: null,
            given_name: name?.firstName,
            gender: "",
            family_name: name?.lastName,
            email: "",
            born_on: dateOfBirth,
        });
    }

    return _passengers;

    // Model Examples

    // Input -----------------------------
    /*{
        id,
        dateOfBirth,
        name: {
            firstName: "STEPHANE",
            lastName: "MARTIN"
        },
        contact: {
            phones: [
                {
                "countryCallingCode": "33",
                "number": "487692704"
                }
            ]
        },
        documents: [
            {
                documentType: "PASSPORT",
                number: "012345678",
                expiryDate: "2009-04-14",
                issuanceCountry: "GB",
                nationality: "GB",
                holder: true
            }
        ]
    }*/

    // Output ---------------------------------
    /*{
        "type": "adult",
        "title": "mr",
        "phone_number": "+17327999546",
        "loyalty_programme_accounts": [],
        "infant_passenger_id": null,
        "id": "pas_0000Ac6K7OtiPbsp1NTVxK",
        "given_name": "Mohammed",
        "gender": "m",
        "family_name": "Adinan",
        "email": "m.adinan@yahoo.com",
        "born_on": "1992-03-23"
    }*/

}

const return_available_services = (data, dictionaries) => {

    return [
        {
            maximum_quantity: 1,
            segment_ids: [
                ""
            ],
            passenger_ids: [
                ""
            ],
            total_currency: "",
            total_amount: "",
            metadata: {
                maximum_length_cm: null,
                maximum_height_cm: null,
                maximum_depth_cm: null,
                maximum_weight_kg: 23,
                type: ""
            },
            type: "",
            id: ""
        }
    ]
}

export const get_flight_offer_object_from_amadeus_data = async (data, dictionary={}) => {

    const {
        id,
        price,
        validatingAirlineCodes,
        instantTicketingRequired,
        travelerPricings,
    } = data;
    
    const {
        aircraft={},
        carriers={},
        currencies={},
        locations={},
    } = dictionary;
    
    const dictionary_example ={
        "locations": {
            "ACC": {
                "cityCode": "ACC",
                "countryCode": "GH"
            },
            "ADD": {
                "cityCode": "ADD",
                "countryCode": "ET"
            },
            "BRU": {
                "cityCode": "BRU",
                "countryCode": "BE"
            },
            "CMN": {
                "cityCode": "CMN",
                "countryCode": "MA"
            },
            "CDG": {
                "cityCode": "PAR",
                "countryCode": "FR"
            },
            "AMS": {
                "cityCode": "AMS",
                "countryCode": "NL"
            },
            "AGP": {
                "cityCode": "AGP",
                "countryCode": "ES"
            },
            "CAI": {
                "cityCode": "CAI",
                "countryCode": "EG"
            },
            "IST": {
                "cityCode": "IST",
                "countryCode": "TR"
            },
            "DXB": {
                "cityCode": "DXB",
                "countryCode": "AE"
            },
            "KGL": {
                "cityCode": "KGL",
                "countryCode": "RW"
            },
            "ZRH": {
                "cityCode": "ZRH",
                "countryCode": "CH"
            },
            "AUH": {
                "cityCode": "AUH",
                "countryCode": "AE"
            },
            "FRA": {
                "cityCode": "FRA",
                "countryCode": "DE"
            },
            "LHR": {
                "cityCode": "LON",
                "countryCode": "GB"
            },
            "LIS": {
                "cityCode": "LIS",
                "countryCode": "PT"
            },
            "MUC": {
                "cityCode": "MUC",
                "countryCode": "DE"
            },
            "NBO": {
                "cityCode": "NBO",
                "countryCode": "KE"
            },
            "KWI": {
                "cityCode": "KWI",
                "countryCode": "KW"
            },
            "DOH": {
                "cityCode": "DOH",
                "countryCode": "QA"
            }
        },
        "aircraft": {
            "221": "AIRBUS  A220-100",
            "223": "AIRBUS  A220-300",
            "295": "EMBRAER 195 E2",
            "318": "AIRBUS A318",
            "319": "AIRBUS A319",
            "320": "AIRBUS A320",
            "332": "AIRBUS A330-200",
            "333": "AIRBUS A330-300",
            "350": "AIRBUS INDUSTRIE A350",
            "359": "AIRBUS A350-900",
            "388": "AIRBUS A380-800",
            "737": "BOEING 737 ALL SERIES PASSENGER",
            "738": "BOEING 737-800",
            "744": "BOEING 747-400",
            "773": "BOEING 777-300",
            "777": "BOEING 777-200/300",
            "788": "BOEING 787-8",
            "7M8": "BOEING 737 MAX 8",
            "32A": "AIRBUS A320 (SHARKLETS)",
            "32N": "AIRBUS A320NEO",
            "32Q": "AIRBUS A321NEO",
            "AT7": "ATR 72",
            "73H": "BOEING 737-800 (WINGLETS)",
            "77W": "BOEING 777-300ER",
            "ERJ": "EMBRAER RJ135/140/145"
        },
        "currencies": {
            "USD": "US DOLLAR"
        },
        "carriers": {
            "KL": "KLM ROYAL DUTCH AIRLINES",
            "QR": "QATAR AIRWAYS",
            "6X": "AMADEUS SIX",
            "AF": "AIR FRANCE",
            "KQ": "KENYA AIRWAYS",
            "MS": "EGYPTAIR",
            "EK": "EMIRATES",
            "KU": "KUWAIT AIRWAYS",
            "WB": "RWANDAIR",
            "LX": "SWISS INTERNATIONAL AIR LINES",
            "ET": "ETHIOPIAN AIRLINES",
            "BT": "AIR BALTIC",
            "AT": "ROYAL AIR MAROC",
            "EY": "ETIHAD AIRWAYS",
            "TK": "TURKISH AIRLINES",
            "SN": "BRUSSELS AIRLINES",
            "LH": "LUFTHANSA",
            "BA": "BRITISH AIRWAYS"
        }
    }

    const amadeus_obj_example = {
        "type": "flight-offer",
        "id": "1",
        "source": "GDS",
        "instantTicketingRequired": false,
        "nonHomogeneous": false,
        "oneWay": false,
        "isUpsellOffer": false,
        "lastTicketingDate": "2025-09-25",
        "lastTicketingDateTime": "2025-09-25",
        "numberOfBookableSeats": 9,
        "itineraries": [
            {
                "duration": "PT9H45M",
                "segments": [
                    {
                        "departure": {
                            "iataCode": "ACC",
                            "terminal": "3",
                            "at": "2025-09-25T06:05:00"
                        },
                        "arrival": {
                            "iataCode": "CMN",
                            "terminal": "2",
                            "at": "2025-09-25T11:30:00"
                        },
                        "carrierCode": "AT",
                        "number": "514",
                        "aircraft": {
                            "code": "73H"
                        },
                        "operating": {
                            "carrierCode": "AT"
                        },
                        "duration": "PT4H25M",
                        "id": "70",
                        "numberOfStops": 0,
                        "blacklistedInEU": false
                    },
                    {
                        "departure": {
                            "iataCode": "CMN",
                            "terminal": "1",
                            "at": "2025-09-25T13:40:00"
                        },
                        "arrival": {
                            "iataCode": "LHR",
                            "terminal": "4",
                            "at": "2025-09-25T16:50:00"
                        },
                        "carrierCode": "AT",
                        "number": "800",
                        "aircraft": {
                            "code": "7M8"
                        },
                        "operating": {
                            "carrierCode": "AT"
                        },
                        "duration": "PT3H10M",
                        "id": "71",
                        "numberOfStops": 0,
                        "blacklistedInEU": false
                    }
                ]
            }
        ],
        "price": {
            "currency": "USD",
            "total": "388.60",
            "base": "75.00",
            "fees": [
                {
                    "amount": "0.00",
                    "type": "SUPPLIER"
                },
                {
                    "amount": "0.00",
                    "type": "TICKETING"
                }
            ],
            "grandTotal": "388.60"
        },
        "pricingOptions": {
            "fareType": [
                "PUBLISHED"
            ],
            "includedCheckedBagsOnly": true
        },
        "validatingAirlineCodes": [
            "AT"
        ],
        "travelerPricings": [
            {
                "travelerId": "1",
                "fareOption": "STANDARD",
                "travelerType": "ADULT",
                "price": {
                    "currency": "USD",
                    "total": "388.60",
                    "base": "75.00"
                },
                "fareDetailsBySegment": [
                    {
                        "segmentId": "70",
                        "cabin": "ECONOMY",
                        "fareBasis": "RA0WAAFA",
                        "brandedFare": "CLASSIC",
                        "brandedFareLabel": "CLASSIC",
                        "class": "R",
                        "includedCheckedBags": {
                            "quantity": 2
                        },
                        "includedCabinBags": {
                            "quantity": 1
                        },
                        "amenities": [
                            {
                                "description": "CHECKED BAG THIRD",
                                "isChargeable": true,
                                "amenityType": "BAGGAGE",
                                "amenityProvider": {
                                    "name": "BrandedFare"
                                }
                            },
                            {
                                "description": "PRE RESERVATION SEAT ASSIGNMEN",
                                "isChargeable": true,
                                "amenityType": "PRE_RESERVED_SEAT",
                                "amenityProvider": {
                                    "name": "BrandedFare"
                                }
                            },
                            {
                                "description": "MEAL BEVERAGE",
                                "isChargeable": false,
                                "amenityType": "MEAL",
                                "amenityProvider": {
                                    "name": "BrandedFare"
                                }
                            },
                            {
                                "description": "100 PERCENT MILES",
                                "isChargeable": false,
                                "amenityType": "BRANDED_FARES",
                                "amenityProvider": {
                                    "name": "BrandedFare"
                                }
                            },
                            {
                                "description": "CHANGE BEFORE DEPARTURE",
                                "isChargeable": true,
                                "amenityType": "BRANDED_FARES",
                                "amenityProvider": {
                                    "name": "BrandedFare"
                                }
                            },
                            {
                                "description": "CHANGE AFTER DEPARTURE",
                                "isChargeable": true,
                                "amenityType": "BRANDED_FARES",
                                "amenityProvider": {
                                    "name": "BrandedFare"
                                }
                            }
                        ]
                    },
                    {
                        "segmentId": "71",
                        "cabin": "ECONOMY",
                        "fareBasis": "RA0WAAFA",
                        "brandedFare": "CLASSIC",
                        "brandedFareLabel": "CLASSIC",
                        "class": "R",
                        "includedCheckedBags": {
                            "quantity": 2
                        },
                        "includedCabinBags": {
                            "quantity": 1
                        },
                        "amenities": [
                            {
                                "description": "CHECKED BAG THIRD",
                                "isChargeable": true,
                                "amenityType": "BAGGAGE",
                                "amenityProvider": {
                                    "name": "BrandedFare"
                                }
                            },
                            {
                                "description": "PRE RESERVATION SEAT ASSIGNMEN",
                                "isChargeable": true,
                                "amenityType": "PRE_RESERVED_SEAT",
                                "amenityProvider": {
                                    "name": "BrandedFare"
                                }
                            },
                            {
                                "description": "MEAL BEVERAGE",
                                "isChargeable": false,
                                "amenityType": "MEAL",
                                "amenityProvider": {
                                    "name": "BrandedFare"
                                }
                            },
                            {
                                "description": "100 PERCENT MILES",
                                "isChargeable": false,
                                "amenityType": "BRANDED_FARES",
                                "amenityProvider": {
                                    "name": "BrandedFare"
                                }
                            },
                            {
                                "description": "CHANGE BEFORE DEPARTURE",
                                "isChargeable": true,
                                "amenityType": "BRANDED_FARES",
                                "amenityProvider": {
                                    "name": "BrandedFare"
                                }
                            },
                            {
                                "description": "CHANGE AFTER DEPARTURE",
                                "isChargeable": true,
                                "amenityType": "BRANDED_FARES",
                                "amenityProvider": {
                                    "name": "BrandedFare"
                                }
                            }
                        ]
                    }
                ]
            }
        ]
    }

    const _slices = await return_slices(data, dictionary);
    const _passengers = await return_passengers(data, dictionary);
    return {
        id,
        intended_payment_methods: [],
        total_emissions_kg: "N/A",
        payment_requirements: {
            requires_instant_payment: true,
            price_guarantee_expires_at: "",
            payment_required_by: ""
        },
        supported_passenger_identity_document_types: [],
        passenger_identity_documents_required: false,
        tax_currency: price?.currency,
        base_currency: price?.currency,
        base_amount: price?.total, //price?.base
        supported_loyalty_programmes: [],
        private_fares: [],
        tax_amount: "0",
        total_currency: price?.currency,
        live_mode: false,
        total_amount: price?.grandTotal,
        created_at: "",
        slices: _slices,
        passengers: _passengers,
        conditions: {
            refund_before_departure: {
                penalty_currency: "",
                penalty_amount: "",
                allowed: false
            },
            change_before_departure: {
                penalty_currency: "",
                penalty_amount: "",
                allowed: false
            }
        },
        updated_at: "",
        expires_at: "",
        partial: false,
        owner: {
            logo_symbol_url: `https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/${validatingAirlineCodes?.[0]}.svg`,
            logo_lockup_url: `https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/${validatingAirlineCodes?.[0]}.svg`,
            conditions_of_carriage_url: "https://www.britishairways.com/en-gb/information/legal/british-airways/general-conditions-of-carriage",
            iata_code: validatingAirlineCodes?.[0],
            name: (carriers?.[validatingAirlineCodes?.[0]] || ""),
            id: ""
        },
    }

}

export const get_full_flight_details_from_amadeus_data = async (amadeus_data, dictionary={}) => {

    const {
        aircraft={},
        carriers={},
        currencies={},
        locations={},
    } = dictionary;

    let offer_data = amadeus_data?.data?.flightOffers[0];

    const {
        id,
        itineraries,
        price,
        validatingAirlineCodes,
        instantTicketingRequired,
        travelerPricings,
    } = offer_data;

    let obj = {
        "headers": {
            "date": "Tue, 21 Oct 2025 01:29:57 GMT",
            "content-type": "application/vnd.amadeus+json",
            "content-length": "14994",
            "connection": "close",
            "ama-internal-message-version": "14.1",
            "ama-request-id": "0001337ZS4GK5W",
            "ama-gateway-request-id": "rrt-0b588a12f3003f18c-b-eu-54635-42425424-1",
            "access-control-allow-headers": "origin, x-requested-with, accept, Content-Type, Authorization",
            "access-control-max-age": "3628800",
            "access-control-allow-methods": "*",
            "server": "Amadeus",
            "access-control-allow-origin": "*"
        },
        "statusCode": 200,
        "request": {
            "host": "test.api.amadeus.com",
            "port": 443,
            "ssl": true,
            "scheme": "https",
            "verb": "POST",
            "path": "/v1/shopping/flight-offers/pricing?include=credit-card-fees,detailed-fare-rules",
            "params": "{\"data\":{\"type\":\"flight-offers-pricing\",\"flightOffers\":[{\"type\":\"flight-offer\",\"id\":\"1\",\"source\":\"GDS\",\"instantTicketingRequired\":false,\"nonHomogeneous\":false,\"oneWay\":false,\"isUpsellOffer\":false,\"lastTicketingDate\":\"2025-10-21\",\"lastTicketingDateTime\":\"2025-10-21\",\"numberOfBookableSeats\":9,\"itineraries\":[{\"duration\":\"PT9H45M\",\"segments\":[{\"departure\":{\"iataCode\":\"ACC\",\"terminal\":\"3\",\"at\":\"2025-10-21T06:05:00\"},\"arrival\":{\"iataCode\":\"CMN\",\"terminal\":\"2\",\"at\":\"2025-10-21T11:30:00\"},\"carrierCode\":\"AT\",\"number\":\"514\",\"aircraft\":{\"code\":\"73H\"},\"operating\":{\"carrierCode\":\"AT\"},\"duration\":\"PT4H25M\",\"id\":\"95\",\"numberOfStops\":0,\"blacklistedInEU\":false},{\"departure\":{\"iataCode\":\"CMN\",\"terminal\":\"1\",\"at\":\"2025-10-21T13:40:00\"},\"arrival\":{\"iataCode\":\"LHR\",\"terminal\":\"4\",\"at\":\"2025-10-21T16:50:00\"},\"carrierCode\":\"AT\",\"number\":\"800\",\"aircraft\":{\"code\":\"7M8\"},\"operating\":{\"carrierCode\":\"AT\"},\"duration\":\"PT3H10M\",\"id\":\"96\",\"numberOfStops\":0,\"blacklistedInEU\":false}]}],\"price\":{\"currency\":\"USD\",\"total\":\"386.20\",\"base\":\"75.00\",\"fees\":[{\"amount\":\"0.00\",\"type\":\"SUPPLIER\"},{\"amount\":\"0.00\",\"type\":\"TICKETING\"}],\"grandTotal\":\"386.20\"},\"pricingOptions\":{\"fareType\":[\"PUBLISHED\"],\"includedCheckedBagsOnly\":true},\"validatingAirlineCodes\":[\"AT\"],\"travelerPricings\":[{\"travelerId\":\"1\",\"fareOption\":\"STANDARD\",\"travelerType\":\"ADULT\",\"price\":{\"currency\":\"USD\",\"total\":\"386.20\",\"base\":\"75.00\"},\"fareDetailsBySegment\":[{\"segmentId\":\"95\",\"cabin\":\"ECONOMY\",\"fareBasis\":\"RA0WAAFA\",\"brandedFare\":\"CLASSIC\",\"brandedFareLabel\":\"CLASSIC\",\"class\":\"R\",\"includedCheckedBags\":{\"quantity\":2},\"includedCabinBags\":{\"quantity\":1},\"amenities\":[{\"description\":\"CHECKED BAG THIRD\",\"isChargeable\":true,\"amenityType\":\"BAGGAGE\",\"amenityProvider\":{\"name\":\"BrandedFare\"}},{\"description\":\"PRE RESERVATION SEAT ASSIGNMEN\",\"isChargeable\":true,\"amenityType\":\"PRE_RESERVED_SEAT\",\"amenityProvider\":{\"name\":\"BrandedFare\"}},{\"description\":\"MEAL BEVERAGE\",\"isChargeable\":false,\"amenityType\":\"MEAL\",\"amenityProvider\":{\"name\":\"BrandedFare\"}},{\"description\":\"100 PERCENT MILES\",\"isChargeable\":false,\"amenityType\":\"BRANDED_FARES\",\"amenityProvider\":{\"name\":\"BrandedFare\"}},{\"description\":\"CHANGE BEFORE DEPARTURE\",\"isChargeable\":true,\"amenityType\":\"BRANDED_FARES\",\"amenityProvider\":{\"name\":\"BrandedFare\"}},{\"description\":\"CHANGE AFTER DEPARTURE\",\"isChargeable\":true,\"amenityType\":\"BRANDED_FARES\",\"amenityProvider\":{\"name\":\"BrandedFare\"}}]},{\"segmentId\":\"96\",\"cabin\":\"ECONOMY\",\"fareBasis\":\"RA0WAAFA\",\"brandedFare\":\"CLASSIC\",\"brandedFareLabel\":\"CLASSIC\",\"class\":\"R\",\"includedCheckedBags\":{\"quantity\":2},\"includedCabinBags\":{\"quantity\":1},\"amenities\":[{\"description\":\"CHECKED BAG THIRD\",\"isChargeable\":true,\"amenityType\":\"BAGGAGE\",\"amenityProvider\":{\"name\":\"BrandedFare\"}},{\"description\":\"PRE RESERVATION SEAT ASSIGNMEN\",\"isChargeable\":true,\"amenityType\":\"PRE_RESERVED_SEAT\",\"amenityProvider\":{\"name\":\"BrandedFare\"}},{\"description\":\"MEAL BEVERAGE\",\"isChargeable\":false,\"amenityType\":\"MEAL\",\"amenityProvider\":{\"name\":\"BrandedFare\"}},{\"description\":\"100 PERCENT MILES\",\"isChargeable\":false,\"amenityType\":\"BRANDED_FARES\",\"amenityProvider\":{\"name\":\"BrandedFare\"}},{\"description\":\"CHANGE BEFORE DEPARTURE\",\"isChargeable\":true,\"amenityType\":\"BRANDED_FARES\",\"amenityProvider\":{\"name\":\"BrandedFare\"}},{\"description\":\"CHANGE AFTER DEPARTURE\",\"isChargeable\":true,\"amenityType\":\"BRANDED_FARES\",\"amenityProvider\":{\"name\":\"BrandedFare\"}}]}]}]}]}}",
            "queryPath": "/v1/shopping/flight-offers/pricing?include=credit-card-fees,detailed-fare-rules",
            "bearerToken": "WNgYCSG06qDTzkQTHAAzEytoD4dv",
            "clientVersion": "11.0.0",
            "languageVersion": "16.13.1",
            "appId": null,
            "appVersion": null,
            "headers": {
                "User-Agent": "amadeus-node/11.0.0 node/16.13.1",
                "Accept": "application/json, application/vnd.amadeus+json",
                "Authorization": "Bearer WNgYCSG06qDTzkQTHAAzEytoD4dv",
                "Content-Type": "application/vnd.amadeus+json"
            },
            "ListHTTPOverride": [
                "/v2/shopping/flight-offers",
                "/v1/shopping/seatmaps",
                "/v1/shopping/availability/flight-availabilities",
                "/v2/shopping/flight-offers/prediction",
                "/v1/shopping/flight-offers/pricing",
                "/v1/shopping/flight-offers/upselling"
            ]
        },
        "body": "{\"data\":{\"type\":\"flight-offers-pricing\",\"flightOffers\":[{\"type\":\"flight-offer\",\"id\":\"1\",\"source\":\"GDS\",\"instantTicketingRequired\":false,\"nonHomogeneous\":false,\"paymentCardRequired\":false,\"lastTicketingDate\":\"2025-10-21\",\"itineraries\":[{\"segments\":[{\"departure\":{\"iataCode\":\"ACC\",\"terminal\":\"3\",\"at\":\"2025-10-21T06:05:00\"},\"arrival\":{\"iataCode\":\"CMN\",\"terminal\":\"2\",\"at\":\"2025-10-21T11:30:00\"},\"carrierCode\":\"AT\",\"number\":\"514\",\"aircraft\":{\"code\":\"73H\"},\"operating\":{\"carrierCode\":\"AT\"},\"duration\":\"PT4H25M\",\"id\":\"95\",\"numberOfStops\":0,\"co2Emissions\":[{\"weight\":250,\"weightUnit\":\"KG\",\"cabin\":\"ECONOMY\"}]},{\"departure\":{\"iataCode\":\"CMN\",\"terminal\":\"1\",\"at\":\"2025-10-21T13:40:00\"},\"arrival\":{\"iataCode\":\"LHR\",\"terminal\":\"4\",\"at\":\"2025-10-21T16:50:00\"},\"carrierCode\":\"AT\",\"number\":\"800\",\"aircraft\":{\"code\":\"7M8\"},\"operating\":{\"carrierCode\":\"AT\"},\"duration\":\"PT3H10M\",\"id\":\"96\",\"numberOfStops\":0,\"co2Emissions\":[{\"weight\":115,\"weightUnit\":\"KG\",\"cabin\":\"ECONOMY\"}]}]}],\"price\":{\"currency\":\"USD\",\"total\":\"386.20\",\"base\":\"75.00\",\"fees\":[{\"amount\":\"0.00\",\"type\":\"SUPPLIER\"},{\"amount\":\"0.00\",\"type\":\"TICKETING\"},{\"amount\":\"0.00\",\"type\":\"FORM_OF_PAYMENT\"}],\"grandTotal\":\"386.20\",\"billingCurrency\":\"USD\"},\"pricingOptions\":{\"fareType\":[\"PUBLISHED\"],\"includedCheckedBagsOnly\":true},\"validatingAirlineCodes\":[\"AT\"],\"travelerPricings\":[{\"travelerId\":\"1\",\"fareOption\":\"STANDARD\",\"travelerType\":\"ADULT\",\"price\":{\"currency\":\"USD\",\"total\":\"386.20\",\"base\":\"75.00\",\"taxes\":[{\"amount\":\"100.00\",\"code\":\"GH\"},{\"amount\":\"20.20\",\"code\":\"MA\"},{\"amount\":\"2.50\",\"code\":\"S9\"},{\"amount\":\"162.00\",\"code\":\"YQ\"},{\"amount\":\"15.00\",\"code\":\"YR\"},{\"amount\":\"11.50\",\"code\":\"G5\"}],\"refundableTaxes\":\"149.20\"},\"fareDetailsBySegment\":[{\"segmentId\":\"95\",\"cabin\":\"ECONOMY\",\"fareBasis\":\"RA0WAAFA\",\"brandedFare\":\"CLASSIC\",\"class\":\"R\",\"includedCheckedBags\":{\"quantity\":2}},{\"segmentId\":\"96\",\"cabin\":\"ECONOMY\",\"fareBasis\":\"RA0WAAFA\",\"brandedFare\":\"CLASSIC\",\"class\":\"R\",\"includedCheckedBags\":{\"quantity\":2}}]}]}],\"bookingRequirements\":{\"emailAddressRequired\":true,\"mobilePhoneNumberRequired\":true}},\"included\":{\"detailed-fare-rules\":{\"1\":{\"fareBasis\":\"RA0WAAFA\",\"name\":\"ADVANCE PURCHASE EXCURSION\",\"fareNotes\":{\"descriptions\":[{\"descriptionType\":\"GENERAL INFORMATION\",\"text\":\"RU.RULE APPLICATION AT  FARES APPLICATION CLASS OF SERVICE THESE FARES APPLY FOR ECONOMY CLASS SERVICE. TYPES OF TRANSPORTATION THIS RULE GOVERNS ONE-WAY AND ROUND-TRIP FARES. FARES GOVERNED BY THIS RULE CAN BE USED TO CREATE ONE-WAY/ROUND-TRIP/OPEN-JAW/SINGLE OPEN-JAW JOURNEYS. FARES ONLY APPLY IF PURCHASED BEFORE DEPARTURE. CAPACITY LIMITATIONS THE CARRIER SHALL LIMIT THE NUMBER OF PASSENGERS CARRIED ON ANY ONE FLIGHT AT FARES GOVERNED BY THIS RULE AND SUCH FARES WILL NOT NECESSARILY BE AVAILABLE ON ALL FLIGHTS. THE NUMBER OF SEATS WHICH THE CARRIER SHALL MAKE AVAILABLE ON A GIVEN FLIGHT WILL BE DETERMINED BY THE CARRIERS BEST JUDGMENT OTHER CONDITIONS FULL AND SEQUENTIAL USE OF FLIGHT COUPONS- THE TICKET/ OR ELECTRONIC TICKET / IS NOT VALID IF THE FIRST COUPON HAS NOT BEEN USED AND WILL NOT BE HONORED IF ALL THE COUPONS ARE NOT USED IN THE SEQUENCE PROVIDED IN THE TICKET / OR ELECTRONIC TICKET / . THE FARE THAT APPLIES ON THE DATE OF PURCHASE IS ONLY VALID FOR THE ENTIRE ITINERARY AND THE SPECIFIC TRAVEL DATES MENTIONED ON THE TICKET. ANY MODIFICATION MAY REQUIRE THE PAYMENT OF AN ADDITIONAL AMOUNT. MN.MIN STAY NONE UNLESS OTHERWISE SPECIFIED MX.MAX STAY NONE UNLESS OTHERWISE SPECIFIED SR.SALES RESTRICT \\nRESERVATIONS MUST BE MADE AND TICKETS ISSUED ON/BEFORE 12NOV 25. *** GENERAL RULE FOLLOWS *** FROM/TO EUROPE \\nIF THE FARE COMPONENT IS ON ONE OR MORE OF THE FOLLOWING ANY AT FLIGHT OPERATED BY AT TICKETS MUST BE ISSUED ON AT  AND MAY NOT BE SOLD IN LEBANON/NIGERIA/ANGOLA/EGYPT/HONDURAS/CONGO (BRAZZAVILLE)/RUSSIA OR - SALE IS RESTRICTED TO SPECIFIC AGENTS. TICKETS MUST BE ISSUED ON AT  AND MAY NOT BE SOLD IN LEBANON/NIGERIA/ANGOLA/EGYPT/HONDURAS/CONGO (BRAZZAVILLE)/RUSSIA OR - SALE IS RESTRICTED TO SPECIFIC AGENTS. TICKETS MUST BE ISSUED ON AT  AND MAY NOT BE SOLD IN LEBANON/NIGERIA/ANGOLA/EGYPT/HONDURAS/CONGO (BRAZZAVILLE)/RUSSIA OR - SALE IS RESTRICTED TO SPECIFIC AGENTS. TICKETS MUST BE ISSUED ON AT  AND MAY NOT BE SOLD IN LEBANON/NIGERIA/ANGOLA/EGYPT/HONDURAS/CONGO (BRAZZAVILLE)/RUSSIA OR - TICKETS MUST BE ISSUED ON AT  OR HR AND MAY NOT BE SOLD IN LEBANON/NIGERIA/ANGOLA/EGYPT/HONDURAS/CONGO (BRAZZAVILLE)/RUSSIA OR - TICKETS MUST BE ISSUED ON AT  OR GP AND MAY NOT BE SOLD IN LEBANON/NIGERIA/ANGOLA/EGYPT/HONDURAS/CONGO (BRAZZAVILLE)/RUSSIA OR - TICKETS MUST BE ISSUED ON AT  OR HC AND MAY NOT BE SOLD IN LEBANON/NIGERIA/ANGOLA/EGYPT/HONDURAS/CONGO (BRAZZAVILLE)/RUSSIA OR - TICKETS MUST BE ISSUED ON AT  OR HF AND MAY NOT BE SOLD IN LEBANON/NIGERIA/ANGOLA/EGYPT/HONDURAS/CONGO (BRAZZAVILLE)/RUSSIA OR - TICKETS MUST BE ISSUED ON AT  OR AS AND MAY NOT BE SOLD IN LEBANON/NIGERIA/ANGOLA/EGYPT/HONDURAS/CONGO (BRAZZAVILLE)/RUSSIA \\nIF THE FARE COMPONENT IS ON ONE OR MORE OF THE FOLLOWING AT FLIGHTS 5000 THROUGH 5999 AT FLIGHTS 9000 THROUGH 9999 TICKETS MUST BE ISSUED ON AT  AND MAY NOT BE SOLD IN LEBANON/NIGERIA/ANGOLA/EGYPT/HONDURAS/CONGO (BRAZZAVILLE)/RUSSIA \\nOTHERWISE TICKETS MUST BE ISSUED ON AT  AND MAY NOT BE SOLD IN LEBANON/NIGERIA/ANGOLA/EGYPT/HONDURAS/CONGO (BRAZZAVILLE)/RUSSIA AP.ADVANCE RES/TKT \\nRESERVATIONS ARE REQUIRED FOR ALL SECTORS. FL.FLT APPLICATION \\nTHE FARE COMPONENT MUST BE ON ONE OR MORE OF THE FOLLOWING ANY AT FLIGHT OPERATED BY AT. CD.CHILD DISCOUNTS FOR ONE WAY FARES \\nACCOMPANIED CHILD 2-11 - CHARGE 75 PERCENT OF THE FARE. TICKETING CODE - BASE FARE CODE PLUS CH. MUST BE ACCOMPANIED ON ALL FLIGHTS IN SAME COMPARTMENT BY ADULT 18 OR OLDER OR - INFANT UNDER 2 WITH A SEAT - CHARGE 75 PERCENT OF THE FARE. TICKETING CODE - BASE FARE CODE PLUS INS. MUST BE ACCOMPANIED ON ALL FLIGHTS IN SAME COMPARTMENT BY ADULT 18 OR OLDER OR - 1ST INFANT UNDER 2 WITHOUT A SEAT - CHARGE 10 PERCENT OF THE FARE. TICKETING CODE - BASE FARE CODE PLUS INF. MUST BE ACCOMPANIED ON ALL FLIGHTS IN SAME COMPARTMENT BY ADULT 18 OR OLDER OR - UNACCOMPANIED CHILD 4-14 - CHARGE 100 PERCENT OF THE FARE PLUS EUR 50.00. TICKET DESIGNATOR - UM. AD.AGTS DISCOUNTS NONE UNLESS OTHERWISE SPECIFIED SO.STOPOVERS BETWEEN EUROPE AND AFRICA FOR ONE WAY RA0WAAFA TYPE FARES NOTE - GENERAL RULE DOES NOT APPLY \\nNO STOPOVERS PERMITTED. TF.TRANSFERS/RTGS \\nUNLIMITED TRANSFERS PERMITTED ON THE PRICING UNIT FARE BREAK SURFACE SECTORS NOT PERMITTED AND EMBEDDED SURFACE SECTORS PERMITTED ON THE FARE COMPONENT. SU.SURCHARGES NONE UNLESS OTHERWISE SPECIFIED CO.COMBINABILITY DOUBLE OPEN JAWS/CIRCLE TRIPS NOT PERMITTED. APPLICABLE ADD-ON CONSTRUCTION IS ADDRESSED IN MISCELLANEOUS PROVISIONS - CATEGORY 23. END-ON-END END-ON-END COMBINATIONS PERMITTED WITH DOMESTIC FARES. VALIDATE ALL FARE COMPONENTS. FARES MUST BE SHOWN SEPARATELY ON THE TICKET. TRAVEL MUST BE VIA THE POINT OF COMBINATION. SIDE TRIPS PERMITTED. OPEN JAWS/ROUND TRIPS FARES MAY BE COMBINED ON A HALF ROUND TRIP BASIS -TO FORM SINGLE OPEN JAWS. A MAXIMUM OF TWO INTERNATIONAL FARE COMPONENTS PERMITTED. -TO FORM ROUND TRIPS PROVIDED - COMBINATIONS ARE WITH ANY FARE FOR CARRIER AT/AS IN ANY RULE AND TARIFF. MD.MISCELLANEOUS DATA \\nTHIS FARE MUST NOT BE USED AS THE HIGH OR THE LOW FARE WHEN CALCULATING A DIFFERENTIAL. THIS FARE MUST NOT BE USED AS THE THROUGH FARE WHEN PRICING A FARE COMPONENT WITH A DIFFERENTIAL. VC.VOLUNTARY CHANGES VOLUNTARY CHANGES CONDITIONS MAY APPLY FOR AUTOMATED REISSUE/REVALIDATION REFER TO PENALTIES CATEGORY *PE FOR DETAILS \\nVR.VOLUNTARY REFUNDS VOLUNTARY CHANGES CONDITIONS MAY APPLY FOR AUTOMATED REFUNDS REFER TO PENALTIES CATEGORY *PE FOR DETAILS \\n\\n\"},{\"descriptionType\":\"PENALTIES\",\"text\":\"PE.PENALTIES FOR RA0WAAFA TYPE FARES \\nCANCELLATIONS \\nANY TIME TICKET IS NON-REFUNDABLE IN CASE OF REFUND. TICKET IS NON-REFUNDABLE IN CASE OF NO-SHOW. NOTE - THE YQ REFUND FOLLOWS THE SAME CONDITIONS OF THE APPLICABLE FARE. \\nCHANGES \\nANY TIME PER DIRECTION CHARGE EUR 150.00 FOR REISSUE/ REVALIDATION. CHANGES NOT PERMITTED IN CASE OF NO-SHOW. NOTE - UPGRADE TO HIGHER FARE MUST BE TO THE HIGHER AVAILABLE CLASS IN THE FLIGHT DATE DISPLAY. \"}]},\"segmentId\":\"95\"},\"2\":{\"fareBasis\":\"RA0WAAFA\",\"name\":\"ADVANCE PURCHASE EXCURSION\",\"fareNotes\":{\"descriptions\":[{\"descriptionType\":\"GENERAL INFORMATION\",\"text\":\"RU.RULE APPLICATION AT  FARES APPLICATION CLASS OF SERVICE THESE FARES APPLY FOR ECONOMY CLASS SERVICE. TYPES OF TRANSPORTATION THIS RULE GOVERNS ONE-WAY AND ROUND-TRIP FARES. FARES GOVERNED BY THIS RULE CAN BE USED TO CREATE ONE-WAY/ROUND-TRIP/OPEN-JAW/SINGLE OPEN-JAW JOURNEYS. FARES ONLY APPLY IF PURCHASED BEFORE DEPARTURE. CAPACITY LIMITATIONS THE CARRIER SHALL LIMIT THE NUMBER OF PASSENGERS CARRIED ON ANY ONE FLIGHT AT FARES GOVERNED BY THIS RULE AND SUCH FARES WILL NOT NECESSARILY BE AVAILABLE ON ALL FLIGHTS. THE NUMBER OF SEATS WHICH THE CARRIER SHALL MAKE AVAILABLE ON A GIVEN FLIGHT WILL BE DETERMINED BY THE CARRIERS BEST JUDGMENT OTHER CONDITIONS FULL AND SEQUENTIAL USE OF FLIGHT COUPONS- THE TICKET/ OR ELECTRONIC TICKET / IS NOT VALID IF THE FIRST COUPON HAS NOT BEEN USED AND WILL NOT BE HONORED IF ALL THE COUPONS ARE NOT USED IN THE SEQUENCE PROVIDED IN THE TICKET / OR ELECTRONIC TICKET / . THE FARE THAT APPLIES ON THE DATE OF PURCHASE IS ONLY VALID FOR THE ENTIRE ITINERARY AND THE SPECIFIC TRAVEL DATES MENTIONED ON THE TICKET. ANY MODIFICATION MAY REQUIRE THE PAYMENT OF AN ADDITIONAL AMOUNT. MN.MIN STAY NONE UNLESS OTHERWISE SPECIFIED MX.MAX STAY NONE UNLESS OTHERWISE SPECIFIED SR.SALES RESTRICT \\nRESERVATIONS MUST BE MADE AND TICKETS ISSUED ON/BEFORE 12NOV 25. *** GENERAL RULE FOLLOWS *** FROM/TO EUROPE \\nIF THE FARE COMPONENT IS ON ONE OR MORE OF THE FOLLOWING ANY AT FLIGHT OPERATED BY AT TICKETS MUST BE ISSUED ON AT  AND MAY NOT BE SOLD IN LEBANON/NIGERIA/ANGOLA/EGYPT/HONDURAS/CONGO (BRAZZAVILLE)/RUSSIA OR - SALE IS RESTRICTED TO SPECIFIC AGENTS. TICKETS MUST BE ISSUED ON AT  AND MAY NOT BE SOLD IN LEBANON/NIGERIA/ANGOLA/EGYPT/HONDURAS/CONGO (BRAZZAVILLE)/RUSSIA OR - SALE IS RESTRICTED TO SPECIFIC AGENTS. TICKETS MUST BE ISSUED ON AT  AND MAY NOT BE SOLD IN LEBANON/NIGERIA/ANGOLA/EGYPT/HONDURAS/CONGO (BRAZZAVILLE)/RUSSIA OR - SALE IS RESTRICTED TO SPECIFIC AGENTS. TICKETS MUST BE ISSUED ON AT  AND MAY NOT BE SOLD IN LEBANON/NIGERIA/ANGOLA/EGYPT/HONDURAS/CONGO (BRAZZAVILLE)/RUSSIA OR - TICKETS MUST BE ISSUED ON AT  OR HR AND MAY NOT BE SOLD IN LEBANON/NIGERIA/ANGOLA/EGYPT/HONDURAS/CONGO (BRAZZAVILLE)/RUSSIA OR - TICKETS MUST BE ISSUED ON AT  OR GP AND MAY NOT BE SOLD IN LEBANON/NIGERIA/ANGOLA/EGYPT/HONDURAS/CONGO (BRAZZAVILLE)/RUSSIA OR - TICKETS MUST BE ISSUED ON AT  OR HC AND MAY NOT BE SOLD IN LEBANON/NIGERIA/ANGOLA/EGYPT/HONDURAS/CONGO (BRAZZAVILLE)/RUSSIA OR - TICKETS MUST BE ISSUED ON AT  OR HF AND MAY NOT BE SOLD IN LEBANON/NIGERIA/ANGOLA/EGYPT/HONDURAS/CONGO (BRAZZAVILLE)/RUSSIA OR - TICKETS MUST BE ISSUED ON AT  OR AS AND MAY NOT BE SOLD IN LEBANON/NIGERIA/ANGOLA/EGYPT/HONDURAS/CONGO (BRAZZAVILLE)/RUSSIA \\nIF THE FARE COMPONENT IS ON ONE OR MORE OF THE FOLLOWING AT FLIGHTS 5000 THROUGH 5999 AT FLIGHTS 9000 THROUGH 9999 TICKETS MUST BE ISSUED ON AT  AND MAY NOT BE SOLD IN LEBANON/NIGERIA/ANGOLA/EGYPT/HONDURAS/CONGO (BRAZZAVILLE)/RUSSIA \\nOTHERWISE TICKETS MUST BE ISSUED ON AT  AND MAY NOT BE SOLD IN LEBANON/NIGERIA/ANGOLA/EGYPT/HONDURAS/CONGO (BRAZZAVILLE)/RUSSIA AP.ADVANCE RES/TKT \\nRESERVATIONS ARE REQUIRED FOR ALL SECTORS. FL.FLT APPLICATION \\nTHE FARE COMPONENT MUST BE ON ONE OR MORE OF THE FOLLOWING ANY AT FLIGHT OPERATED BY AT. CD.CHILD DISCOUNTS FOR ONE WAY FARES \\nACCOMPANIED CHILD 2-11 - CHARGE 75 PERCENT OF THE FARE. TICKETING CODE - BASE FARE CODE PLUS CH. MUST BE ACCOMPANIED ON ALL FLIGHTS IN SAME COMPARTMENT BY ADULT 18 OR OLDER OR - INFANT UNDER 2 WITH A SEAT - CHARGE 75 PERCENT OF THE FARE. TICKETING CODE - BASE FARE CODE PLUS INS. MUST BE ACCOMPANIED ON ALL FLIGHTS IN SAME COMPARTMENT BY ADULT 18 OR OLDER OR - 1ST INFANT UNDER 2 WITHOUT A SEAT - CHARGE 10 PERCENT OF THE FARE. TICKETING CODE - BASE FARE CODE PLUS INF. MUST BE ACCOMPANIED ON ALL FLIGHTS IN SAME COMPARTMENT BY ADULT 18 OR OLDER OR - UNACCOMPANIED CHILD 4-14 - CHARGE 100 PERCENT OF THE FARE PLUS EUR 50.00. TICKET DESIGNATOR - UM. AD.AGTS DISCOUNTS NONE UNLESS OTHERWISE SPECIFIED SO.STOPOVERS BETWEEN EUROPE AND AFRICA FOR ONE WAY RA0WAAFA TYPE FARES NOTE - GENERAL RULE DOES NOT APPLY \\nNO STOPOVERS PERMITTED. TF.TRANSFERS/RTGS \\nUNLIMITED TRANSFERS PERMITTED ON THE PRICING UNIT FARE BREAK SURFACE SECTORS NOT PERMITTED AND EMBEDDED SURFACE SECTORS PERMITTED ON THE FARE COMPONENT. SU.SURCHARGES NONE UNLESS OTHERWISE SPECIFIED CO.COMBINABILITY DOUBLE OPEN JAWS/CIRCLE TRIPS NOT PERMITTED. APPLICABLE ADD-ON CONSTRUCTION IS ADDRESSED IN MISCELLANEOUS PROVISIONS - CATEGORY 23. END-ON-END END-ON-END COMBINATIONS PERMITTED WITH DOMESTIC FARES. VALIDATE ALL FARE COMPONENTS. FARES MUST BE SHOWN SEPARATELY ON THE TICKET. TRAVEL MUST BE VIA THE POINT OF COMBINATION. SIDE TRIPS PERMITTED. OPEN JAWS/ROUND TRIPS FARES MAY BE COMBINED ON A HALF ROUND TRIP BASIS -TO FORM SINGLE OPEN JAWS. A MAXIMUM OF TWO INTERNATIONAL FARE COMPONENTS PERMITTED. -TO FORM ROUND TRIPS PROVIDED - COMBINATIONS ARE WITH ANY FARE FOR CARRIER AT/AS IN ANY RULE AND TARIFF. MD.MISCELLANEOUS DATA \\nTHIS FARE MUST NOT BE USED AS THE HIGH OR THE LOW FARE WHEN CALCULATING A DIFFERENTIAL. THIS FARE MUST NOT BE USED AS THE THROUGH FARE WHEN PRICING A FARE COMPONENT WITH A DIFFERENTIAL. VC.VOLUNTARY CHANGES VOLUNTARY CHANGES CONDITIONS MAY APPLY FOR AUTOMATED REISSUE/REVALIDATION REFER TO PENALTIES CATEGORY *PE FOR DETAILS \\nVR.VOLUNTARY REFUNDS VOLUNTARY CHANGES CONDITIONS MAY APPLY FOR AUTOMATED REFUNDS REFER TO PENALTIES CATEGORY *PE FOR DETAILS \\n\\n\"},{\"descriptionType\":\"PENALTIES\",\"text\":\"PE.PENALTIES FOR RA0WAAFA TYPE FARES \\nCANCELLATIONS \\nANY TIME TICKET IS NON-REFUNDABLE IN CASE OF REFUND. TICKET IS NON-REFUNDABLE IN CASE OF NO-SHOW. NOTE - THE YQ REFUND FOLLOWS THE SAME CONDITIONS OF THE APPLICABLE FARE. \\nCHANGES \\nANY TIME PER DIRECTION CHARGE EUR 150.00 FOR REISSUE/ REVALIDATION. CHANGES NOT PERMITTED IN CASE OF NO-SHOW. NOTE - UPGRADE TO HIGHER FARE MUST BE TO THE HIGHER AVAILABLE CLASS IN THE FLIGHT DATE DISPLAY. \"}]},\"segmentId\":\"96\"}},\"credit-card-fees\":{\"1\":{\"brand\":\"VISA\",\"amount\":\"0\",\"currency\":\"EUR\",\"flightOfferId\":\"1\"},\"2\":{\"brand\":\"AMERICAN_EXPRESS\",\"amount\":\"0\",\"currency\":\"EUR\",\"flightOfferId\":\"1\"},\"3\":{\"brand\":\"MASTERCARD\",\"amount\":\"0\",\"currency\":\"EUR\",\"flightOfferId\":\"1\"},\"4\":{\"brand\":\"VISA_ELECTRON\",\"amount\":\"0\",\"currency\":\"EUR\",\"flightOfferId\":\"1\"},\"5\":{\"brand\":\"VISA_DEBIT\",\"amount\":\"0\",\"currency\":\"EUR\",\"flightOfferId\":\"1\"},\"6\":{\"brand\":\"MASTERCARD_DEBIT\",\"amount\":\"0\",\"currency\":\"EUR\",\"flightOfferId\":\"1\"},\"7\":{\"brand\":\"MAESTRO\",\"amount\":\"0\",\"currency\":\"EUR\",\"flightOfferId\":\"1\"},\"8\":{\"brand\":\"DINERS\",\"amount\":\"0\",\"currency\":\"EUR\",\"flightOfferId\":\"1\"}}},\"dictionaries\":{\"locations\":{\"ACC\":{\"cityCode\":\"ACC\",\"countryCode\":\"GH\"},\"CMN\":{\"cityCode\":\"CMN\",\"countryCode\":\"MA\"},\"LHR\":{\"cityCode\":\"LON\",\"countryCode\":\"GB\"}}}}",
        "result": {
            "data": {
                "type": "flight-offers-pricing",
                "flightOffers": [
                    {
                        "type": "flight-offer",
                        "id": "1",
                        "source": "GDS",
                        "instantTicketingRequired": false,
                        "nonHomogeneous": false,
                        "paymentCardRequired": false,
                        "lastTicketingDate": "2025-10-21",
                        "itineraries": [
                            {
                                "segments": [
                                    {
                                        "departure": {
                                            "iataCode": "ACC",
                                            "terminal": "3",
                                            "at": "2025-10-21T06:05:00"
                                        },
                                        "arrival": {
                                            "iataCode": "CMN",
                                            "terminal": "2",
                                            "at": "2025-10-21T11:30:00"
                                        },
                                        "carrierCode": "AT",
                                        "number": "514",
                                        "aircraft": {
                                            "code": "73H"
                                        },
                                        "operating": {
                                            "carrierCode": "AT"
                                        },
                                        "duration": "PT4H25M",
                                        "id": "95",
                                        "numberOfStops": 0,
                                        "co2Emissions": [
                                            {
                                                "weight": 250,
                                                "weightUnit": "KG",
                                                "cabin": "ECONOMY"
                                            }
                                        ]
                                    },
                                    {
                                        "departure": {
                                            "iataCode": "CMN",
                                            "terminal": "1",
                                            "at": "2025-10-21T13:40:00"
                                        },
                                        "arrival": {
                                            "iataCode": "LHR",
                                            "terminal": "4",
                                            "at": "2025-10-21T16:50:00"
                                        },
                                        "carrierCode": "AT",
                                        "number": "800",
                                        "aircraft": {
                                            "code": "7M8"
                                        },
                                        "operating": {
                                            "carrierCode": "AT"
                                        },
                                        "duration": "PT3H10M",
                                        "id": "96",
                                        "numberOfStops": 0,
                                        "co2Emissions": [
                                            {
                                                "weight": 115,
                                                "weightUnit": "KG",
                                                "cabin": "ECONOMY"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "price": {
                            "currency": "USD",
                            "total": "386.20",
                            "base": "75.00",
                            "fees": [
                                {
                                    "amount": "0.00",
                                    "type": "SUPPLIER"
                                },
                                {
                                    "amount": "0.00",
                                    "type": "TICKETING"
                                },
                                {
                                    "amount": "0.00",
                                    "type": "FORM_OF_PAYMENT"
                                }
                            ],
                            "grandTotal": "386.20",
                            "billingCurrency": "USD"
                        },
                        "pricingOptions": {
                            "fareType": [
                                "PUBLISHED"
                            ],
                            "includedCheckedBagsOnly": true
                        },
                        "validatingAirlineCodes": [
                            "AT"
                        ],
                        "travelerPricings": [
                            {
                                "travelerId": "1",
                                "fareOption": "STANDARD",
                                "travelerType": "ADULT",
                                "price": {
                                    "currency": "USD",
                                    "total": "386.20",
                                    "base": "75.00",
                                    "taxes": [
                                        {
                                            "amount": "100.00",
                                            "code": "GH"
                                        },
                                        {
                                            "amount": "20.20",
                                            "code": "MA"
                                        },
                                        {
                                            "amount": "2.50",
                                            "code": "S9"
                                        },
                                        {
                                            "amount": "162.00",
                                            "code": "YQ"
                                        },
                                        {
                                            "amount": "15.00",
                                            "code": "YR"
                                        },
                                        {
                                            "amount": "11.50",
                                            "code": "G5"
                                        }
                                    ],
                                    "refundableTaxes": "149.20"
                                },
                                "fareDetailsBySegment": [
                                    {
                                        "segmentId": "95",
                                        "cabin": "ECONOMY",
                                        "fareBasis": "RA0WAAFA",
                                        "brandedFare": "CLASSIC",
                                        "class": "R",
                                        "includedCheckedBags": {
                                            "quantity": 2
                                        }
                                    },
                                    {
                                        "segmentId": "96",
                                        "cabin": "ECONOMY",
                                        "fareBasis": "RA0WAAFA",
                                        "brandedFare": "CLASSIC",
                                        "class": "R",
                                        "includedCheckedBags": {
                                            "quantity": 2
                                        }
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "bookingRequirements": {
                    "emailAddressRequired": true,
                    "mobilePhoneNumberRequired": true
                }
            },
            "included": {
                "detailed-fare-rules": {
                    "1": {
                        "fareBasis": "RA0WAAFA",
                        "name": "ADVANCE PURCHASE EXCURSION",
                        "fareNotes": {
                            "descriptions": [
                                {
                                    "descriptionType": "GENERAL INFORMATION",
                                    "text": "RU.RULE APPLICATION AT  FARES APPLICATION CLASS OF SERVICE THESE FARES APPLY FOR ECONOMY CLASS SERVICE. TYPES OF TRANSPORTATION THIS RULE GOVERNS ONE-WAY AND ROUND-TRIP FARES. FARES GOVERNED BY THIS RULE CAN BE USED TO CREATE ONE-WAY/ROUND-TRIP/OPEN-JAW/SINGLE OPEN-JAW JOURNEYS. FARES ONLY APPLY IF PURCHASED BEFORE DEPARTURE. CAPACITY LIMITATIONS THE CARRIER SHALL LIMIT THE NUMBER OF PASSENGERS CARRIED ON ANY ONE FLIGHT AT FARES GOVERNED BY THIS RULE AND SUCH FARES WILL NOT NECESSARILY BE AVAILABLE ON ALL FLIGHTS. THE NUMBER OF SEATS WHICH THE CARRIER SHALL MAKE AVAILABLE ON A GIVEN FLIGHT WILL BE DETERMINED BY THE CARRIERS BEST JUDGMENT OTHER CONDITIONS FULL AND SEQUENTIAL USE OF FLIGHT COUPONS- THE TICKET/ OR ELECTRONIC TICKET / IS NOT VALID IF THE FIRST COUPON HAS NOT BEEN USED AND WILL NOT BE HONORED IF ALL THE COUPONS ARE NOT USED IN THE SEQUENCE PROVIDED IN THE TICKET / OR ELECTRONIC TICKET / . THE FARE THAT APPLIES ON THE DATE OF PURCHASE IS ONLY VALID FOR THE ENTIRE ITINERARY AND THE SPECIFIC TRAVEL DATES MENTIONED ON THE TICKET. ANY MODIFICATION MAY REQUIRE THE PAYMENT OF AN ADDITIONAL AMOUNT. MN.MIN STAY NONE UNLESS OTHERWISE SPECIFIED MX.MAX STAY NONE UNLESS OTHERWISE SPECIFIED SR.SALES RESTRICT \nRESERVATIONS MUST BE MADE AND TICKETS ISSUED ON/BEFORE 12NOV 25. *** GENERAL RULE FOLLOWS *** FROM/TO EUROPE \nIF THE FARE COMPONENT IS ON ONE OR MORE OF THE FOLLOWING ANY AT FLIGHT OPERATED BY AT TICKETS MUST BE ISSUED ON AT  AND MAY NOT BE SOLD IN LEBANON/NIGERIA/ANGOLA/EGYPT/HONDURAS/CONGO (BRAZZAVILLE)/RUSSIA OR - SALE IS RESTRICTED TO SPECIFIC AGENTS. TICKETS MUST BE ISSUED ON AT  AND MAY NOT BE SOLD IN LEBANON/NIGERIA/ANGOLA/EGYPT/HONDURAS/CONGO (BRAZZAVILLE)/RUSSIA OR - SALE IS RESTRICTED TO SPECIFIC AGENTS. TICKETS MUST BE ISSUED ON AT  AND MAY NOT BE SOLD IN LEBANON/NIGERIA/ANGOLA/EGYPT/HONDURAS/CONGO (BRAZZAVILLE)/RUSSIA OR - SALE IS RESTRICTED TO SPECIFIC AGENTS. TICKETS MUST BE ISSUED ON AT  AND MAY NOT BE SOLD IN LEBANON/NIGERIA/ANGOLA/EGYPT/HONDURAS/CONGO (BRAZZAVILLE)/RUSSIA OR - TICKETS MUST BE ISSUED ON AT  OR HR AND MAY NOT BE SOLD IN LEBANON/NIGERIA/ANGOLA/EGYPT/HONDURAS/CONGO (BRAZZAVILLE)/RUSSIA OR - TICKETS MUST BE ISSUED ON AT  OR GP AND MAY NOT BE SOLD IN LEBANON/NIGERIA/ANGOLA/EGYPT/HONDURAS/CONGO (BRAZZAVILLE)/RUSSIA OR - TICKETS MUST BE ISSUED ON AT  OR HC AND MAY NOT BE SOLD IN LEBANON/NIGERIA/ANGOLA/EGYPT/HONDURAS/CONGO (BRAZZAVILLE)/RUSSIA OR - TICKETS MUST BE ISSUED ON AT  OR HF AND MAY NOT BE SOLD IN LEBANON/NIGERIA/ANGOLA/EGYPT/HONDURAS/CONGO (BRAZZAVILLE)/RUSSIA OR - TICKETS MUST BE ISSUED ON AT  OR AS AND MAY NOT BE SOLD IN LEBANON/NIGERIA/ANGOLA/EGYPT/HONDURAS/CONGO (BRAZZAVILLE)/RUSSIA \nIF THE FARE COMPONENT IS ON ONE OR MORE OF THE FOLLOWING AT FLIGHTS 5000 THROUGH 5999 AT FLIGHTS 9000 THROUGH 9999 TICKETS MUST BE ISSUED ON AT  AND MAY NOT BE SOLD IN LEBANON/NIGERIA/ANGOLA/EGYPT/HONDURAS/CONGO (BRAZZAVILLE)/RUSSIA \nOTHERWISE TICKETS MUST BE ISSUED ON AT  AND MAY NOT BE SOLD IN LEBANON/NIGERIA/ANGOLA/EGYPT/HONDURAS/CONGO (BRAZZAVILLE)/RUSSIA AP.ADVANCE RES/TKT \nRESERVATIONS ARE REQUIRED FOR ALL SECTORS. FL.FLT APPLICATION \nTHE FARE COMPONENT MUST BE ON ONE OR MORE OF THE FOLLOWING ANY AT FLIGHT OPERATED BY AT. CD.CHILD DISCOUNTS FOR ONE WAY FARES \nACCOMPANIED CHILD 2-11 - CHARGE 75 PERCENT OF THE FARE. TICKETING CODE - BASE FARE CODE PLUS CH. MUST BE ACCOMPANIED ON ALL FLIGHTS IN SAME COMPARTMENT BY ADULT 18 OR OLDER OR - INFANT UNDER 2 WITH A SEAT - CHARGE 75 PERCENT OF THE FARE. TICKETING CODE - BASE FARE CODE PLUS INS. MUST BE ACCOMPANIED ON ALL FLIGHTS IN SAME COMPARTMENT BY ADULT 18 OR OLDER OR - 1ST INFANT UNDER 2 WITHOUT A SEAT - CHARGE 10 PERCENT OF THE FARE. TICKETING CODE - BASE FARE CODE PLUS INF. MUST BE ACCOMPANIED ON ALL FLIGHTS IN SAME COMPARTMENT BY ADULT 18 OR OLDER OR - UNACCOMPANIED CHILD 4-14 - CHARGE 100 PERCENT OF THE FARE PLUS EUR 50.00. TICKET DESIGNATOR - UM. AD.AGTS DISCOUNTS NONE UNLESS OTHERWISE SPECIFIED SO.STOPOVERS BETWEEN EUROPE AND AFRICA FOR ONE WAY RA0WAAFA TYPE FARES NOTE - GENERAL RULE DOES NOT APPLY \nNO STOPOVERS PERMITTED. TF.TRANSFERS/RTGS \nUNLIMITED TRANSFERS PERMITTED ON THE PRICING UNIT FARE BREAK SURFACE SECTORS NOT PERMITTED AND EMBEDDED SURFACE SECTORS PERMITTED ON THE FARE COMPONENT. SU.SURCHARGES NONE UNLESS OTHERWISE SPECIFIED CO.COMBINABILITY DOUBLE OPEN JAWS/CIRCLE TRIPS NOT PERMITTED. APPLICABLE ADD-ON CONSTRUCTION IS ADDRESSED IN MISCELLANEOUS PROVISIONS - CATEGORY 23. END-ON-END END-ON-END COMBINATIONS PERMITTED WITH DOMESTIC FARES. VALIDATE ALL FARE COMPONENTS. FARES MUST BE SHOWN SEPARATELY ON THE TICKET. TRAVEL MUST BE VIA THE POINT OF COMBINATION. SIDE TRIPS PERMITTED. OPEN JAWS/ROUND TRIPS FARES MAY BE COMBINED ON A HALF ROUND TRIP BASIS -TO FORM SINGLE OPEN JAWS. A MAXIMUM OF TWO INTERNATIONAL FARE COMPONENTS PERMITTED. -TO FORM ROUND TRIPS PROVIDED - COMBINATIONS ARE WITH ANY FARE FOR CARRIER AT/AS IN ANY RULE AND TARIFF. MD.MISCELLANEOUS DATA \nTHIS FARE MUST NOT BE USED AS THE HIGH OR THE LOW FARE WHEN CALCULATING A DIFFERENTIAL. THIS FARE MUST NOT BE USED AS THE THROUGH FARE WHEN PRICING A FARE COMPONENT WITH A DIFFERENTIAL. VC.VOLUNTARY CHANGES VOLUNTARY CHANGES CONDITIONS MAY APPLY FOR AUTOMATED REISSUE/REVALIDATION REFER TO PENALTIES CATEGORY *PE FOR DETAILS \nVR.VOLUNTARY REFUNDS VOLUNTARY CHANGES CONDITIONS MAY APPLY FOR AUTOMATED REFUNDS REFER TO PENALTIES CATEGORY *PE FOR DETAILS \n\n"
                                },
                                {
                                    "descriptionType": "PENALTIES",
                                    "text": "PE.PENALTIES FOR RA0WAAFA TYPE FARES \nCANCELLATIONS \nANY TIME TICKET IS NON-REFUNDABLE IN CASE OF REFUND. TICKET IS NON-REFUNDABLE IN CASE OF NO-SHOW. NOTE - THE YQ REFUND FOLLOWS THE SAME CONDITIONS OF THE APPLICABLE FARE. \nCHANGES \nANY TIME PER DIRECTION CHARGE EUR 150.00 FOR REISSUE/ REVALIDATION. CHANGES NOT PERMITTED IN CASE OF NO-SHOW. NOTE - UPGRADE TO HIGHER FARE MUST BE TO THE HIGHER AVAILABLE CLASS IN THE FLIGHT DATE DISPLAY. "
                                }
                            ]
                        },
                        "segmentId": "95"
                    },
                    "2": {
                        "fareBasis": "RA0WAAFA",
                        "name": "ADVANCE PURCHASE EXCURSION",
                        "fareNotes": {
                            "descriptions": [
                                {
                                    "descriptionType": "GENERAL INFORMATION",
                                    "text": "RU.RULE APPLICATION AT  FARES APPLICATION CLASS OF SERVICE THESE FARES APPLY FOR ECONOMY CLASS SERVICE. TYPES OF TRANSPORTATION THIS RULE GOVERNS ONE-WAY AND ROUND-TRIP FARES. FARES GOVERNED BY THIS RULE CAN BE USED TO CREATE ONE-WAY/ROUND-TRIP/OPEN-JAW/SINGLE OPEN-JAW JOURNEYS. FARES ONLY APPLY IF PURCHASED BEFORE DEPARTURE. CAPACITY LIMITATIONS THE CARRIER SHALL LIMIT THE NUMBER OF PASSENGERS CARRIED ON ANY ONE FLIGHT AT FARES GOVERNED BY THIS RULE AND SUCH FARES WILL NOT NECESSARILY BE AVAILABLE ON ALL FLIGHTS. THE NUMBER OF SEATS WHICH THE CARRIER SHALL MAKE AVAILABLE ON A GIVEN FLIGHT WILL BE DETERMINED BY THE CARRIERS BEST JUDGMENT OTHER CONDITIONS FULL AND SEQUENTIAL USE OF FLIGHT COUPONS- THE TICKET/ OR ELECTRONIC TICKET / IS NOT VALID IF THE FIRST COUPON HAS NOT BEEN USED AND WILL NOT BE HONORED IF ALL THE COUPONS ARE NOT USED IN THE SEQUENCE PROVIDED IN THE TICKET / OR ELECTRONIC TICKET / . THE FARE THAT APPLIES ON THE DATE OF PURCHASE IS ONLY VALID FOR THE ENTIRE ITINERARY AND THE SPECIFIC TRAVEL DATES MENTIONED ON THE TICKET. ANY MODIFICATION MAY REQUIRE THE PAYMENT OF AN ADDITIONAL AMOUNT. MN.MIN STAY NONE UNLESS OTHERWISE SPECIFIED MX.MAX STAY NONE UNLESS OTHERWISE SPECIFIED SR.SALES RESTRICT \nRESERVATIONS MUST BE MADE AND TICKETS ISSUED ON/BEFORE 12NOV 25. *** GENERAL RULE FOLLOWS *** FROM/TO EUROPE \nIF THE FARE COMPONENT IS ON ONE OR MORE OF THE FOLLOWING ANY AT FLIGHT OPERATED BY AT TICKETS MUST BE ISSUED ON AT  AND MAY NOT BE SOLD IN LEBANON/NIGERIA/ANGOLA/EGYPT/HONDURAS/CONGO (BRAZZAVILLE)/RUSSIA OR - SALE IS RESTRICTED TO SPECIFIC AGENTS. TICKETS MUST BE ISSUED ON AT  AND MAY NOT BE SOLD IN LEBANON/NIGERIA/ANGOLA/EGYPT/HONDURAS/CONGO (BRAZZAVILLE)/RUSSIA OR - SALE IS RESTRICTED TO SPECIFIC AGENTS. TICKETS MUST BE ISSUED ON AT  AND MAY NOT BE SOLD IN LEBANON/NIGERIA/ANGOLA/EGYPT/HONDURAS/CONGO (BRAZZAVILLE)/RUSSIA OR - SALE IS RESTRICTED TO SPECIFIC AGENTS. TICKETS MUST BE ISSUED ON AT  AND MAY NOT BE SOLD IN LEBANON/NIGERIA/ANGOLA/EGYPT/HONDURAS/CONGO (BRAZZAVILLE)/RUSSIA OR - TICKETS MUST BE ISSUED ON AT  OR HR AND MAY NOT BE SOLD IN LEBANON/NIGERIA/ANGOLA/EGYPT/HONDURAS/CONGO (BRAZZAVILLE)/RUSSIA OR - TICKETS MUST BE ISSUED ON AT  OR GP AND MAY NOT BE SOLD IN LEBANON/NIGERIA/ANGOLA/EGYPT/HONDURAS/CONGO (BRAZZAVILLE)/RUSSIA OR - TICKETS MUST BE ISSUED ON AT  OR HC AND MAY NOT BE SOLD IN LEBANON/NIGERIA/ANGOLA/EGYPT/HONDURAS/CONGO (BRAZZAVILLE)/RUSSIA OR - TICKETS MUST BE ISSUED ON AT  OR HF AND MAY NOT BE SOLD IN LEBANON/NIGERIA/ANGOLA/EGYPT/HONDURAS/CONGO (BRAZZAVILLE)/RUSSIA OR - TICKETS MUST BE ISSUED ON AT  OR AS AND MAY NOT BE SOLD IN LEBANON/NIGERIA/ANGOLA/EGYPT/HONDURAS/CONGO (BRAZZAVILLE)/RUSSIA \nIF THE FARE COMPONENT IS ON ONE OR MORE OF THE FOLLOWING AT FLIGHTS 5000 THROUGH 5999 AT FLIGHTS 9000 THROUGH 9999 TICKETS MUST BE ISSUED ON AT  AND MAY NOT BE SOLD IN LEBANON/NIGERIA/ANGOLA/EGYPT/HONDURAS/CONGO (BRAZZAVILLE)/RUSSIA \nOTHERWISE TICKETS MUST BE ISSUED ON AT  AND MAY NOT BE SOLD IN LEBANON/NIGERIA/ANGOLA/EGYPT/HONDURAS/CONGO (BRAZZAVILLE)/RUSSIA AP.ADVANCE RES/TKT \nRESERVATIONS ARE REQUIRED FOR ALL SECTORS. FL.FLT APPLICATION \nTHE FARE COMPONENT MUST BE ON ONE OR MORE OF THE FOLLOWING ANY AT FLIGHT OPERATED BY AT. CD.CHILD DISCOUNTS FOR ONE WAY FARES \nACCOMPANIED CHILD 2-11 - CHARGE 75 PERCENT OF THE FARE. TICKETING CODE - BASE FARE CODE PLUS CH. MUST BE ACCOMPANIED ON ALL FLIGHTS IN SAME COMPARTMENT BY ADULT 18 OR OLDER OR - INFANT UNDER 2 WITH A SEAT - CHARGE 75 PERCENT OF THE FARE. TICKETING CODE - BASE FARE CODE PLUS INS. MUST BE ACCOMPANIED ON ALL FLIGHTS IN SAME COMPARTMENT BY ADULT 18 OR OLDER OR - 1ST INFANT UNDER 2 WITHOUT A SEAT - CHARGE 10 PERCENT OF THE FARE. TICKETING CODE - BASE FARE CODE PLUS INF. MUST BE ACCOMPANIED ON ALL FLIGHTS IN SAME COMPARTMENT BY ADULT 18 OR OLDER OR - UNACCOMPANIED CHILD 4-14 - CHARGE 100 PERCENT OF THE FARE PLUS EUR 50.00. TICKET DESIGNATOR - UM. AD.AGTS DISCOUNTS NONE UNLESS OTHERWISE SPECIFIED SO.STOPOVERS BETWEEN EUROPE AND AFRICA FOR ONE WAY RA0WAAFA TYPE FARES NOTE - GENERAL RULE DOES NOT APPLY \nNO STOPOVERS PERMITTED. TF.TRANSFERS/RTGS \nUNLIMITED TRANSFERS PERMITTED ON THE PRICING UNIT FARE BREAK SURFACE SECTORS NOT PERMITTED AND EMBEDDED SURFACE SECTORS PERMITTED ON THE FARE COMPONENT. SU.SURCHARGES NONE UNLESS OTHERWISE SPECIFIED CO.COMBINABILITY DOUBLE OPEN JAWS/CIRCLE TRIPS NOT PERMITTED. APPLICABLE ADD-ON CONSTRUCTION IS ADDRESSED IN MISCELLANEOUS PROVISIONS - CATEGORY 23. END-ON-END END-ON-END COMBINATIONS PERMITTED WITH DOMESTIC FARES. VALIDATE ALL FARE COMPONENTS. FARES MUST BE SHOWN SEPARATELY ON THE TICKET. TRAVEL MUST BE VIA THE POINT OF COMBINATION. SIDE TRIPS PERMITTED. OPEN JAWS/ROUND TRIPS FARES MAY BE COMBINED ON A HALF ROUND TRIP BASIS -TO FORM SINGLE OPEN JAWS. A MAXIMUM OF TWO INTERNATIONAL FARE COMPONENTS PERMITTED. -TO FORM ROUND TRIPS PROVIDED - COMBINATIONS ARE WITH ANY FARE FOR CARRIER AT/AS IN ANY RULE AND TARIFF. MD.MISCELLANEOUS DATA \nTHIS FARE MUST NOT BE USED AS THE HIGH OR THE LOW FARE WHEN CALCULATING A DIFFERENTIAL. THIS FARE MUST NOT BE USED AS THE THROUGH FARE WHEN PRICING A FARE COMPONENT WITH A DIFFERENTIAL. VC.VOLUNTARY CHANGES VOLUNTARY CHANGES CONDITIONS MAY APPLY FOR AUTOMATED REISSUE/REVALIDATION REFER TO PENALTIES CATEGORY *PE FOR DETAILS \nVR.VOLUNTARY REFUNDS VOLUNTARY CHANGES CONDITIONS MAY APPLY FOR AUTOMATED REFUNDS REFER TO PENALTIES CATEGORY *PE FOR DETAILS \n\n"
                                },
                                {
                                    "descriptionType": "PENALTIES",
                                    "text": "PE.PENALTIES FOR RA0WAAFA TYPE FARES \nCANCELLATIONS \nANY TIME TICKET IS NON-REFUNDABLE IN CASE OF REFUND. TICKET IS NON-REFUNDABLE IN CASE OF NO-SHOW. NOTE - THE YQ REFUND FOLLOWS THE SAME CONDITIONS OF THE APPLICABLE FARE. \nCHANGES \nANY TIME PER DIRECTION CHARGE EUR 150.00 FOR REISSUE/ REVALIDATION. CHANGES NOT PERMITTED IN CASE OF NO-SHOW. NOTE - UPGRADE TO HIGHER FARE MUST BE TO THE HIGHER AVAILABLE CLASS IN THE FLIGHT DATE DISPLAY. "
                                }
                            ]
                        },
                        "segmentId": "96"
                    }
                },
                "credit-card-fees": {
                    "1": {
                        "brand": "VISA",
                        "amount": "0",
                        "currency": "EUR",
                        "flightOfferId": "1"
                    },
                    "2": {
                        "brand": "AMERICAN_EXPRESS",
                        "amount": "0",
                        "currency": "EUR",
                        "flightOfferId": "1"
                    },
                    "3": {
                        "brand": "MASTERCARD",
                        "amount": "0",
                        "currency": "EUR",
                        "flightOfferId": "1"
                    },
                    "4": {
                        "brand": "VISA_ELECTRON",
                        "amount": "0",
                        "currency": "EUR",
                        "flightOfferId": "1"
                    },
                    "5": {
                        "brand": "VISA_DEBIT",
                        "amount": "0",
                        "currency": "EUR",
                        "flightOfferId": "1"
                    },
                    "6": {
                        "brand": "MASTERCARD_DEBIT",
                        "amount": "0",
                        "currency": "EUR",
                        "flightOfferId": "1"
                    },
                    "7": {
                        "brand": "MAESTRO",
                        "amount": "0",
                        "currency": "EUR",
                        "flightOfferId": "1"
                    },
                    "8": {
                        "brand": "DINERS",
                        "amount": "0",
                        "currency": "EUR",
                        "flightOfferId": "1"
                    }
                }
            },
            "dictionaries": {
                "locations": {
                    "ACC": {
                        "cityCode": "ACC",
                        "countryCode": "GH"
                    },
                    "CMN": {
                        "cityCode": "CMN",
                        "countryCode": "MA"
                    },
                    "LHR": {
                        "cityCode": "LON",
                        "countryCode": "GB"
                    }
                }
            }
        },
        "data": {
            "type": "flight-offers-pricing",
            "flightOffers": [
                {
                    "type": "flight-offer",
                    "id": "1",
                    "source": "GDS",
                    "instantTicketingRequired": false,
                    "nonHomogeneous": false,
                    "paymentCardRequired": false,
                    "lastTicketingDate": "2025-10-21",
                    "itineraries": [
                        {
                            "segments": [
                                {
                                    "departure": {
                                        "iataCode": "ACC",
                                        "terminal": "3",
                                        "at": "2025-10-21T06:05:00"
                                    },
                                    "arrival": {
                                        "iataCode": "CMN",
                                        "terminal": "2",
                                        "at": "2025-10-21T11:30:00"
                                    },
                                    "carrierCode": "AT",
                                    "number": "514",
                                    "aircraft": {
                                        "code": "73H"
                                    },
                                    "operating": {
                                        "carrierCode": "AT"
                                    },
                                    "duration": "PT4H25M",
                                    "id": "95",
                                    "numberOfStops": 0,
                                    "co2Emissions": [
                                        {
                                            "weight": 250,
                                            "weightUnit": "KG",
                                            "cabin": "ECONOMY"
                                        }
                                    ]
                                },
                                {
                                    "departure": {
                                        "iataCode": "CMN",
                                        "terminal": "1",
                                        "at": "2025-10-21T13:40:00"
                                    },
                                    "arrival": {
                                        "iataCode": "LHR",
                                        "terminal": "4",
                                        "at": "2025-10-21T16:50:00"
                                    },
                                    "carrierCode": "AT",
                                    "number": "800",
                                    "aircraft": {
                                        "code": "7M8"
                                    },
                                    "operating": {
                                        "carrierCode": "AT"
                                    },
                                    "duration": "PT3H10M",
                                    "id": "96",
                                    "numberOfStops": 0,
                                    "co2Emissions": [
                                        {
                                            "weight": 115,
                                            "weightUnit": "KG",
                                            "cabin": "ECONOMY"
                                        }
                                    ]
                                }
                            ]
                        }
                    ],
                    "price": {
                        "currency": "USD",
                        "total": "386.20",
                        "base": "75.00",
                        "fees": [
                            {
                                "amount": "0.00",
                                "type": "SUPPLIER"
                            },
                            {
                                "amount": "0.00",
                                "type": "TICKETING"
                            },
                            {
                                "amount": "0.00",
                                "type": "FORM_OF_PAYMENT"
                            }
                        ],
                        "grandTotal": "386.20",
                        "billingCurrency": "USD"
                    },
                    "pricingOptions": {
                        "fareType": [
                            "PUBLISHED"
                        ],
                        "includedCheckedBagsOnly": true
                    },
                    "validatingAirlineCodes": [
                        "AT"
                    ],
                    "travelerPricings": [
                        {
                            "travelerId": "1",
                            "fareOption": "STANDARD",
                            "travelerType": "ADULT",
                            "price": {
                                "currency": "USD",
                                "total": "386.20",
                                "base": "75.00",
                                "taxes": [
                                    {
                                        "amount": "100.00",
                                        "code": "GH"
                                    },
                                    {
                                        "amount": "20.20",
                                        "code": "MA"
                                    },
                                    {
                                        "amount": "2.50",
                                        "code": "S9"
                                    },
                                    {
                                        "amount": "162.00",
                                        "code": "YQ"
                                    },
                                    {
                                        "amount": "15.00",
                                        "code": "YR"
                                    },
                                    {
                                        "amount": "11.50",
                                        "code": "G5"
                                    }
                                ],
                                "refundableTaxes": "149.20"
                            },
                            "fareDetailsBySegment": [
                                {
                                    "segmentId": "95",
                                    "cabin": "ECONOMY",
                                    "fareBasis": "RA0WAAFA",
                                    "brandedFare": "CLASSIC",
                                    "class": "R",
                                    "includedCheckedBags": {
                                        "quantity": 2
                                    }
                                },
                                {
                                    "segmentId": "96",
                                    "cabin": "ECONOMY",
                                    "fareBasis": "RA0WAAFA",
                                    "brandedFare": "CLASSIC",
                                    "class": "R",
                                    "includedCheckedBags": {
                                        "quantity": 2
                                    }
                                }
                            ]
                        }
                    ]
                }
            ],
            "bookingRequirements": {
                "emailAddressRequired": true,
                "mobilePhoneNumberRequired": true
            }
        },
        "parsed": true,
        "data_provider": "amadeus"
    }

    const _slices = await return_slices(offer_data, dictionary);
    const _passengers = await return_passengers(offer_data, dictionary);
    const _available_services = await return_available_services(offer_data, dictionary);

    return {
        data: {
            intended_payment_methods: [],
            total_emissions_kg: itineraries?.[0]?.segments?.[0]?.co2Emissions?.[0]?.weight,
            intended_services: [],
            available_airline_credits: null,
            payment_requirements: {
                price_guarantee_expires_at: "",
                payment_required_by: "",
                requires_instant_payment: false
            },
            supported_passenger_identity_document_types: [
                /*"passport",
                "known_traveler_number",
                "passenger_redress_number"*/
            ],
            passenger_identity_documents_required: false,
            available_services: _available_services,
            tax_currency: price?.currency,
            base_currency: price?.currency,
            base_amount: price?.total,
            supported_loyalty_programmes: [],
            private_fares: [],
            tax_amount: "0",
            total_currency: price?.currency,
            total_amount: price?.grandTotal,
            created_at: "",
            live_mode: false,
            slices: _slices,
            passengers: _passengers,
            conditions: {
                refund_before_departure: {
                    penalty_currency: "",
                    penalty_amount: "",
                    allowed: false
                },
                change_before_departure: {
                    penalty_currency: "",
                    penalty_amount: "",
                    allowed: false
                }
            },
            updated_at: "",
            expires_at: "",
            partial: false,
            owner: {
                logo_symbol_url: `https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/${validatingAirlineCodes?.[0]}.svg`,
                logo_lockup_url: `https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/${validatingAirlineCodes?.[0]}.svg`,
                conditions_of_carriage_url: "https://duffelairways.com/dummy-url/conditions-of-carriage",
                iata_code: validatingAirlineCodes?.[0],
                name: (carriers?.[validatingAirlineCodes?.[0]] || ""),
                id: ""
            },
            id,
        }
    }
}

export const return_amadeus_checkout_obj = async (amadeus_data) => {
    return {
        type: "flight-order",
        flightOffers: [amadeus_data.data.flightOffers[0]],
        travelers: [],
    }
}

export const get_amadeus_passenger_obj = (passenger, _id) => {
    const {
        title,
        phone_number,
        infant_passenger_id,
        identity_documents,
        id,
        given_name,
        gender,
        type,
        family_name,
        email,
        born_on
    } = passenger;

    const {
        unique_identifier,
        issuing_country_code,
        validity_country,
        nationality,
        birth_city,
        issuance_city,
        expires_on,
        issuance_date,
    } = identity_documents[0];

    const document_type = identity_documents[0]?.type;
    const phone_number_parts = getCountryCode(phone_number);
    /*{
        formatted,
        withoutCountryCode,
        countryCode,
    }*/
    return {
        id: _id,
        dateOfBirth: born_on,
        name: {
            firstName: family_name,
            lastName: given_name,
        },
        gender,
        contact: {
            emailAddress: email,
            phones: [
                {
                    deviceType: "MOBILE",
                    countryCallingCode: phone_number_parts?.countryCode,
                    number: phone_number_parts?.withoutCountryCode,
                },
            ],
        },
        documents: [
            {
                documentType: "PASSPORT",
                birthPlace: birth_city,
                issuanceLocation: issuance_city,
                issuanceDate: issuance_date,
                number: unique_identifier,
                expiryDate: expires_on,
                issuanceCountry: issuing_country_code,
                validityCountry: validity_country,
                nationality,
                holder: true,
            },
        ],
    };
}

/**
 * @param {Object} obj
 * @returns Default log object from amadeus' order completed details
 */
export const return_booked_flight_log_object_from_amadeus_data = async (obj, dictionary={}) => {
    let order_example = {
        "data": {
            "type": "flight-order",
            "id": "MlpZVkFMfFdBVFNPTnwyMDE1LTExLTAy",
            "queuingOfficeId": "NCE1A0950",
            "associatedRecords": [
                {
                    "reference": "2ZYVAL",
                    "creationDateTime": "2018-07-13T20:17:00",
                    "originSystemCode": "1A",
                    "flightOfferId": "1"
                }
            ],
            "travelers": [
            {
                "id": "1",
                "dateOfBirth": "1982-01-16",
                "name": {
                "firstName": "STEPHANE",
                "lastName": "MARTIN"
                },
                "contact": {
                "phones": [
                    {
                    "countryCallingCode": "33",
                    "number": "487692704"
                    }
                ]
                },
                "documents": [
                {
                    "documentType": "PASSPORT",
                    "number": "012345678",
                    "expiryDate": "2009-04-14",
                    "issuanceCountry": "GB",
                    "nationality": "GB",
                    "holder": true
                }
                ]
            },
            {
                "id": "3",
                "dateOfBirth": "2018-03-24",
                "name": {
                "firstName": "JULES",
                "lastName": "MARTIN"
                }
            },
            {
                "id": "2",
                "dateOfBirth": "2007-10-11",
                "name": {
                "firstName": "EMILIE",
                "lastName": "MARTIN"
                }
            }
            ],
            "flightOffers": [
            {
                "id": "1",
                "type": "flight-offer",
                "source": "GDS",
                "itineraries": [
                {
                    "duration": "PT2H",
                    "segments": [
                    {
                        "id": "1",
                        "duration": "PT2H",
                        "aircraft": {
                        "code": "320"
                        },
                        "numberOfStops": 0,
                        "blacklistedInEU": false,
                        "carrierCode": "IB",
                        "operating": {
                        "carrierCode": "IB"
                        },
                        "number": "3403",
                        "departure": {
                        "at": "2018-09-22T10:15:00",
                        "terminal": "W",
                        "iataCode": "ORY"
                        },
                        "arrival": {
                        "at": "2018-09-22T12:15:00",
                        "terminal": "4",
                        "iataCode": "MAD"
                        },
                        "co2Emissions": [
                        {
                            "weight": "100",
                            "weightUnit": "KG",
                            "cabin": "ECONOMY"
                        }
                        ]
                    }
                    ]
                },
                {
                    "duration": "PT1H20M",
                    "segments": [
                    {
                        "id": "20",
                        "duration": "PT1H20M",
                        "aircraft": {
                        "code": "320"
                        },
                        "numberOfStops": 0,
                        "blacklistedInEU": false,
                        "carrierCode": "IB",
                        "operating": {
                        "carrierCode": "IB"
                        },
                        "number": "3118",
                        "departure": {
                        "at": "2018-09-26T23:05:00",
                        "terminal": "4",
                        "iataCode": "MAD"
                        },
                        "arrival": {
                        "at": "2018-09-26T23:25:00",
                        "terminal": "1",
                        "iataCode": "LIS"
                        },
                        "co2Emissions": [
                        {
                            "weight": "100",
                            "weightUnit": "KG",
                            "cabin": "ECONOMY"
                        }
                        ]
                    }
                    ]
                },
                {
                    "duration": "PT4H30M",
                    "segments": [
                    {
                        "id": "30",
                        "duration": "PT2H",
                        "aircraft": {
                        "code": "320"
                        },
                        "numberOfStops": 0,
                        "blacklistedInEU": false,
                        "carrierCode": "IB",
                        "operating": {
                        "carrierCode": "IB"
                        },
                        "number": "3109",
                        "departure": {
                        "at": "2018-10-04T12:35:00",
                        "terminal": "1",
                        "iataCode": "LIS"
                        },
                        "arrival": {
                        "at": "2018-10-04T14:55:00",
                        "terminal": "4",
                        "iataCode": "MAD"
                        },
                        "co2Emissions": [
                        {
                            "weight": "100",
                            "weightUnit": "KG",
                            "cabin": "ECONOMY"
                        }
                        ]
                    },
                    {
                        "id": "31",
                        "duration": "PT2H30M",
                        "aircraft": {
                        "code": "320"
                        },
                        "numberOfStops": 0,
                        "blacklistedInEU": false,
                        "carrierCode": "IB",
                        "operating": {
                        "carrierCode": "IB"
                        },
                        "number": "3444",
                        "departure": {
                        "at": "2018-10-04T16:05:00",
                        "terminal": "4",
                        "iataCode": "MAD"
                        },
                        "arrival": {
                        "at": "2018-10-04T18:05:00",
                        "terminal": "W",
                        "iataCode": "ORY"
                        },
                        "co2Emissions": [
                        {
                            "weight": "100",
                            "weightUnit": "KG",
                            "cabin": "ECONOMY"
                        }
                        ]
                    }
                    ]
                }
                ],
                "price": {
                "grandTotal": "689.21",
                "total": "423.21",
                "base": "242.00",
                "currency": "EUR",
                "billingCurrency": "EUR",
                "fees": [
                    {
                    "type": "SUPPLIER",
                    "amount": "0"
                    },
                    {
                    "type": "FORM_OF_PAYMENT",
                    "amount": "6"
                    },
                    {
                    "type": "TICKETING",
                    "amount": "0"
                    }
                ],
                "additionalServices": [
                    {
                    "type": "CHECKED_BAGS",
                    "amount": "100"
                    },
                    {
                    "type": "SEATS",
                    "amount": "166"
                    }
                ]
                },
                "pricingOptions": {
                "fareType": [
                    "PUBLISHED"
                ],
                "includedCheckedBags": false
                },
                "validatingAirlineCodes": [
                "IB"
                ],
                "travelerPricings": [
                {
                    "travelerId": "1",
                    "fareOption": "STANDARD",
                    "travelerType": "ADULT",
                    "price": {
                    "currency": "EUR",
                    "total": "200.94",
                    "base": "126",
                    "taxes": [
                        {
                        "code": "YQ",
                        "amount": "0.94"
                        },
                        {
                        "code": "CJ",
                        "amount": "41.67"
                        },
                        {
                        "code": "FR",
                        "amount": "31.33"
                        }
                    ]
                    },
                    "fareDetailsBySegment": [
                    {
                        "segmentId": "1",
                        "cabin": "ECONOMY",
                        "fareBasis": "ANNNNF4K",
                        "brandedFare": "LIGHTONE",
                        "class": "A",
                        "isAllotment": true,
                        "allotmentDetails": {
                        "tourName": "tour",
                        "tourReference": "ref"
                        },
                        "sliceDiceIndicator": "ABCDEF",
                        "includedCheckedBags": {
                        "quantity": 0
                        }
                    },
                    {
                        "segmentId": "20",
                        "cabin": "ECONOMY",
                        "fareBasis": "ANNNNF4K",
                        "brandedFare": "LIGHTONE",
                        "class": "A",
                        "isAllotment": true,
                        "allotmentDetails": {
                        "tourName": "tour",
                        "tourReference": "ref"
                        },
                        "sliceDiceIndicator": "ABCDEF",
                        "includedCheckedBags": {
                        "quantity": 0
                        }
                    },
                    {
                        "segmentId": "30",
                        "cabin": "ECONOMY",
                        "fareBasis": "ANNNNF4K",
                        "brandedFare": "LIGHTONE",
                        "class": "A",
                        "isAllotment": true,
                        "allotmentDetails": {
                        "tourName": "tour",
                        "tourReference": "ref"
                        },
                        "sliceDiceIndicator": "ABCDEF",
                        "includedCheckedBags": {
                        "quantity": 0
                        }
                    },
                    {
                        "segmentId": "31",
                        "cabin": "ECONOMY",
                        "fareBasis": "ANNNNF4K",
                        "brandedFare": "LIGHTONE",
                        "class": "A",
                        "isAllotment": true,
                        "allotmentDetails": {
                        "tourName": "tour",
                        "tourReference": "ref"
                        },
                        "sliceDiceIndicator": "ABCDEF",
                        "includedCheckedBags": {
                        "quantity": 0
                        }
                    }
                    ]
                },
                {
                    "travelerId": "2",
                    "fareOption": "STANDARD",
                    "travelerType": "CHILD",
                    "price": {
                    "currency": "EUR",
                    "total": "180.94",
                    "base": "106",
                    "taxes": [
                        {
                        "code": "YQ",
                        "amount": "0.94"
                        },
                        {
                        "code": "CJ",
                        "amount": "41.67"
                        },
                        {
                        "code": "FR",
                        "amount": "31.33"
                        }
                    ]
                    },
                    "fareDetailsBySegment": [
                    {
                        "segmentId": "1",
                        "cabin": "ECONOMY",
                        "fareBasis": "ANNNNF4K",
                        "brandedFare": "LIGHTONE",
                        "class": "A",
                        "isAllotment": true,
                        "allotmentDetails": {
                        "tourName": "tour",
                        "tourReference": "ref"
                        },
                        "sliceDiceIndicator": "ABCDEF",
                        "includedCheckedBags": {
                        "quantity": 0
                        },
                        "additionalServices": {
                        "chargeableCheckedBags": {
                            "quantity": 1,
                            "weight": 20
                        },
                        "chargeableSeatNumber": "33D"
                        }
                    },
                    {
                        "segmentId": "20",
                        "cabin": "ECONOMY",
                        "fareBasis": "ANNNNF4K",
                        "brandedFare": "LIGHTONE",
                        "class": "A",
                        "isAllotment": true,
                        "allotmentDetails": {
                        "tourName": "tour",
                        "tourReference": "ref"
                        },
                        "sliceDiceIndicator": "ABCDEF",
                        "includedCheckedBags": {
                        "quantity": 0
                        },
                        "additionalServices": {
                        "chargeableCheckedBags": {
                            "quantity": 1,
                            "weight": 20
                        },
                        "chargeableSeatNumber": "28A"
                        }
                    },
                    {
                        "segmentId": "30",
                        "cabin": "ECONOMY",
                        "fareBasis": "ANNNNF4K",
                        "brandedFare": "LIGHTONE",
                        "class": "A",
                        "isAllotment": true,
                        "allotmentDetails": {
                        "tourName": "tour",
                        "tourReference": "ref"
                        },
                        "sliceDiceIndicator": "ABCDEF",
                        "includedCheckedBags": {
                        "quantity": 0
                        },
                        "additionalServices": {
                        "chargeableCheckedBags": {
                            "quantity": 1,
                            "weight": 20
                        },
                        "chargeableSeatNumber": "12C"
                        }
                    },
                    {
                        "segmentId": "31",
                        "cabin": "ECONOMY",
                        "fareBasis": "ANNNNF4K",
                        "brandedFare": "LIGHTONE",
                        "class": "A",
                        "isAllotment": true,
                        "allotmentDetails": {
                        "tourName": "tour",
                        "tourReference": "ref"
                        },
                        "sliceDiceIndicator": "ABCDEF",
                        "includedCheckedBags": {
                        "quantity": 0
                        },
                        "additionalServices": {
                        "chargeableCheckedBags": {
                            "quantity": 1,
                            "weight": 20
                        },
                        "chargeableSeatNumber": "33D"
                        }
                    }
                    ]
                },
                {
                    "travelerId": "3",
                    "fareOption": "STANDARD",
                    "travelerType": "HELD_INFANT",
                    "associatedAdultId": "1",
                    "price": {
                    "currency": "EUR",
                    "total": "41.33",
                    "base": "10",
                    "taxes": [
                        {
                        "code": "FR",
                        "amount": "31.33"
                        }
                    ]
                    },
                    "fareDetailsBySegment": [
                    {
                        "segmentId": "1",
                        "cabin": "ECONOMY",
                        "fareBasis": "ANNNNF4K",
                        "brandedFare": "LIGHTONE",
                        "class": "A",
                        "isAllotment": true,
                        "allotmentDetails": {
                        "tourName": "tour",
                        "tourReference": "ref"
                        },
                        "sliceDiceIndicator": "ABCDEF",
                        "includedCheckedBags": {
                        "quantity": 0
                        }
                    },
                    {
                        "segmentId": "20",
                        "cabin": "ECONOMY",
                        "fareBasis": "ANNNNF4K",
                        "brandedFare": "LIGHTONE",
                        "class": "A",
                        "isAllotment": true,
                        "allotmentDetails": {
                        "tourName": "tour",
                        "tourReference": "ref"
                        },
                        "sliceDiceIndicator": "ABCDEF",
                        "includedCheckedBags": {
                        "quantity": 0
                        }
                    },
                    {
                        "segmentId": "30",
                        "cabin": "ECONOMY",
                        "fareBasis": "ANNNNF4K",
                        "brandedFare": "LIGHTONE",
                        "class": "A",
                        "isAllotment": true,
                        "allotmentDetails": {
                        "tourName": "tour",
                        "tourReference": "ref"
                        },
                        "sliceDiceIndicator": "ABCDEF",
                        "includedCheckedBags": {
                        "quantity": 0
                        }
                    },
                    {
                        "segmentId": "31",
                        "cabin": "ECONOMY",
                        "fareBasis": "ANNNNF4K",
                        "brandedFare": "LIGHTONE",
                        "class": "A",
                        "isAllotment": true,
                        "allotmentDetails": {
                        "tourName": "tour",
                        "tourReference": "ref"
                        },
                        "sliceDiceIndicator": "ABCDEF",
                        "includedCheckedBags": {
                        "quantity": 0
                        }
                    }
                    ]
                }
                ]
            }
            ],
            "ticketingAggreement": {
            "option": "DELAY_TO_CANCEL",
            "dateTime": "2018-08-21T10:15:00.000"
            },
            "contacts": [
            {
                "companyName": "AMADEUS",
                "purpose": "STANDARD",
                "phones": [
                {
                    "deviceType": "FAX",
                    "countryCallingCode": "33",
                    "number": "480080070"
                },
                {
                    "deviceType": "LANDLINE",
                    "countryCallingCode": "33",
                    "number": "480080070"
                }
                ],
                "emailAddress": "support@mail.com",
                "address": {
                "lines": [
                    "485 route du Pin Montard"
                ],
                "postalCode": "06902",
                "cityName": "Sophia Antipolis Cedex",
                "countryCode": "FR"
                }
            }
            ]
        },
        "dictionaries": {
            "locations": {
            "CDG": {
                "cityCode": "PAR",
                "countryCode": "FR"
            },
            "ORY": {
                "cityCode": "PAR",
                "countryCode": "FR"
            },
            "MAD": {
                "cityCode": "MAD",
                "countryCode": "ES"
            }
            }
        }
    };

    const {
        aircraft={},
        carriers={},
        currencies={},
        locations={},
    } = dictionary;

    let tt="one-way";
    if(obj?.flightOffers?.[0]?.itineraries?.length===2){
        tt="round-trip"
    }else if(obj?.flightOffers?.[0]?.itineraries?.length>2){
        tt="multi-city"
    }

    const departure_airport_iata_code=obj?.flightOffers?.[0]?.itineraries?.[0]?.segments?.[0]?.departure?.iataCode;
    let departure_airport = await returnAirportInfoByIATACode(departure_airport_iata_code);
    if(!departure_airport){
        departure_airport = {name: "", city: "", country: "", IATA: "", ICAO: "", lat: "", lon: "", timezone: ""} // default values
    }
    const {
        name: dep_name, 
        city: dep_city,
        country: dep_country, 
        IATA: dep_IATA, 
        ICAO: dep_ICAO, 
        lat: dep_lat, 
        lon: dep_lon, 
        timezone: d_timezone,
    } = departure_airport;

    const destination_airport_iata_code=((obj?.flightOffers?.[0]?.itineraries?.length>1) ? 
                                    obj?.flightOffers?.[0]?.itineraries?.[(obj?.flightOffers?.[0]?.itineraries?.length-1)]?.segments?.[0]?.departure?.iataCode : 
                                    obj?.flightOffers?.[0]?.itineraries?.[0]?.segments?.[0]?.arrival?.iataCode
                            );
    let destination_airport = await returnAirportInfoByIATACode(destination_airport_iata_code);
    if(!destination_airport){
        destination_airport = {name: "", city: "", country: "", IATA: "", ICAO: "", lat: "", lon: "", timezone: ""} // default values
    }

    const last_itin = obj?.flightOffers?.[0]?.itineraries?.[(obj?.flightOffers?.[0]?.itineraries?.length-1)];
    const {
        name: dest_name, 
        city: dest_city,
        country: dest_country, 
        IATA: dest_IATA, 
        ICAO: dest_ICAO, 
        lat: dest_lat, 
        lon: dest_lon, 
        timezone: dest_timezone,
    } = destination_airport;

    const _passengers = await return_adapted_passengers_of_completed_amadeus_flight_order(obj, dictionary);

    return {
        API_PROVIDER: "Amadeus",
        BOOKING_ID: obj?.id,
        TYPE: "Flight",
        AIRLINE_NAME: obj?.owner?.name,
        AIRLINE_IATA: obj?.flightOffers?.[0]?.validatingAirlineCodes,
        TRIP_TYPE: tt,
        CABIN_TYPE: obj?.flightOffers?.[0]?.fareDetailsBySegment?.[0]?.cabin,
        TRAVELERS: _passengers,
        ORIGIN_AIRPORT_NAME: dep_name,
        ORIGIN_AIRPORT_IATA: (dep_IATA || dep_ICAO),
        ORIGIN_CITY_NAME: dep_city,
        DESTINATION_AIRPORT_NAME: dest_name,
        DESTINATION_AIRPORT_IATA: (dest_IATA || dest_ICAO),
        DESTINATION_CITY_NAME: dest_city,
        DEPARTURE_DATE: obj?.flightOffers?.[0]?.itineraries?.[0]?.segments?.[0]?.departure?.at,
        TOTAL_AMOUNT: obj?.flightOffers?.[0]?.price?.grandTotal,
        TOTAL_CURRENCY: obj?.flightOffers?.[0]?.price?.currency,
        RETURN_DATE: last_itin?.segments[0]?.departure?.at,
    }

}

/**
 * 
 */
export const return_booked_flight_order_object_from_amadeus_data = async (data, dictionary={}) => {

    const _slices = await return_adapted_slices_of_completed_amadeus_flight_order(data, dictionary);
    const _passengers = await return_adapted_passengers_of_completed_amadeus_flight_order(data, dictionary);

    const {
        id,
    } = data

    return {
        id,
        "type": "instant",
        "total_currency": "USD",
        "total_amount": "404.59",
        "tax_currency": "USD",
        "tax_amount": "61.72",
        "synced_at": "2023-11-23T14:37:38Z",
        slices: _slices,
        "services": [],
        "payment_status": {
            "price_guarantee_expires_at": null,
            "payment_required_by": null,
            "paid_at": "2023-11-23T14:37:38Z",
            "awaiting_payment": false
        },
        "passengers": _passengers,
        "owner": {
            "name": "American Airlines",
            "logo_symbol_url": "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/AA.svg",
            "logo_lockup_url": "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/AA.svg",
            "id": "arl_00009VME7DAGiJjwomhv32",
            "iata_code": "AA",
            "conditions_of_carriage_url": "https://www.aa.com/i18n/customer-service/support/conditions-of-carriage.jsp"
        },
        "metadata": {},
        "live_mode": false,
        "documents": [
            {
                "unique_identifier": "1",
                "type": "electronic_ticket",
                "passenger_ids": [
                    "pas_0000Ac6K7OtiPbsp1NTVxK"
                ]
            }
        ],
        "created_at": "2023-11-23T14:37:38.485807Z",
        "content": "managed",
        "conditions": {
            "refund_before_departure": {
                "penalty_currency": "GBP",
                "penalty_amount": "50.00",
                "allowed": true
            },
            "change_before_departure": {
                "penalty_currency": null,
                "penalty_amount": null,
                "allowed": false
            }
        },
        "changes": [],
        "cancelled_at": null,
        "cancellation": null,
        "booking_reference": "VXYP4X",
        "base_currency": "USD",
        "base_amount": "342.87",
        "available_actions": [
            "cancel",
            "change",
            "update"
        ],
        "airline_initiated_changes": []
    }
}

/**
 * 
 * @returns 
 */
export const return_amadeus_confirmed_order_example = () => {
    return {
        "data": {
            "type": "flight-order",
            "id": "MlpZVkFMfFdBVFNPTnwyMDE1LTExLTAy",
            "queuingOfficeId": "NCE1A0950",
            "associatedRecords": [
                {
                    "reference": "2ZYVAL",
                    "creationDateTime": "2018-07-13T20:17:00",
                    "originSystemCode": "1A",
                    "flightOfferId": "1"
                }
            ],
            "travelers": [
            {
                "id": "1",
                "dateOfBirth": "1982-01-16",
                "name": {
                "firstName": "STEPHANE",
                "lastName": "MARTIN"
                },
                "contact": {
                "phones": [
                    {
                    "countryCallingCode": "33",
                    "number": "487692704"
                    }
                ]
                },
                "documents": [
                {
                    "documentType": "PASSPORT",
                    "number": "012345678",
                    "expiryDate": "2009-04-14",
                    "issuanceCountry": "GB",
                    "nationality": "GB",
                    "holder": true
                }
                ]
            },
            {
                "id": "3",
                "dateOfBirth": "2018-03-24",
                "name": {
                "firstName": "JULES",
                "lastName": "MARTIN"
                }
            },
            {
                "id": "2",
                "dateOfBirth": "2007-10-11",
                "name": {
                "firstName": "EMILIE",
                "lastName": "MARTIN"
                }
            }
            ],
            "flightOffers": [
            {
                "id": "1",
                "type": "flight-offer",
                "source": "GDS",
                "itineraries": [
                    {
                        "duration": "PT2H",
                        "segments": [
                        {
                            "id": "1",
                            "duration": "PT2H",
                            "aircraft": {
                            "code": "320"
                            },
                            "numberOfStops": 0,
                            "blacklistedInEU": false,
                            "carrierCode": "IB",
                            "operating": {
                            "carrierCode": "IB"
                            },
                            "number": "3403",
                            "departure": {
                            "at": "2018-09-22T10:15:00",
                            "terminal": "W",
                            "iataCode": "ORY"
                            },
                            "arrival": {
                            "at": "2018-09-22T12:15:00",
                            "terminal": "4",
                            "iataCode": "MAD"
                            },
                            "co2Emissions": [
                            {
                                "weight": "100",
                                "weightUnit": "KG",
                                "cabin": "ECONOMY"
                            }
                            ]
                        }
                        ]
                    },
                    {
                        "duration": "PT1H20M",
                        "segments": [
                        {
                            "id": "20",
                            "duration": "PT1H20M",
                            "aircraft": {
                            "code": "320"
                            },
                            "numberOfStops": 0,
                            "blacklistedInEU": false,
                            "carrierCode": "IB",
                            "operating": {
                            "carrierCode": "IB"
                            },
                            "number": "3118",
                            "departure": {
                            "at": "2018-09-26T23:05:00",
                            "terminal": "4",
                            "iataCode": "MAD"
                            },
                            "arrival": {
                            "at": "2018-09-26T23:25:00",
                            "terminal": "1",
                            "iataCode": "LIS"
                            },
                            "co2Emissions": [
                            {
                                "weight": "100",
                                "weightUnit": "KG",
                                "cabin": "ECONOMY"
                            }
                            ]
                        }
                        ]
                    },
                    {
                        "duration": "PT4H30M",
                        "segments": [
                        {
                            "id": "30",
                            "duration": "PT2H",
                            "aircraft": {
                            "code": "320"
                            },
                            "numberOfStops": 0,
                            "blacklistedInEU": false,
                            "carrierCode": "IB",
                            "operating": {
                            "carrierCode": "IB"
                            },
                            "number": "3109",
                            "departure": {
                            "at": "2018-10-04T12:35:00",
                            "terminal": "1",
                            "iataCode": "LIS"
                            },
                            "arrival": {
                            "at": "2018-10-04T14:55:00",
                            "terminal": "4",
                            "iataCode": "MAD"
                            },
                            "co2Emissions": [
                            {
                                "weight": "100",
                                "weightUnit": "KG",
                                "cabin": "ECONOMY"
                            }
                            ]
                        },
                        {
                            "id": "31",
                            "duration": "PT2H30M",
                            "aircraft": {
                            "code": "320"
                            },
                            "numberOfStops": 0,
                            "blacklistedInEU": false,
                            "carrierCode": "IB",
                            "operating": {
                            "carrierCode": "IB"
                            },
                            "number": "3444",
                            "departure": {
                            "at": "2018-10-04T16:05:00",
                            "terminal": "4",
                            "iataCode": "MAD"
                            },
                            "arrival": {
                            "at": "2018-10-04T18:05:00",
                            "terminal": "W",
                            "iataCode": "ORY"
                            },
                            "co2Emissions": [
                            {
                                "weight": "100",
                                "weightUnit": "KG",
                                "cabin": "ECONOMY"
                            }
                            ]
                        }
                        ]
                    }
                ],
                "price": {
                "grandTotal": "689.21",
                "total": "423.21",
                "base": "242.00",
                "currency": "EUR",
                "billingCurrency": "EUR",
                "fees": [
                    {
                    "type": "SUPPLIER",
                    "amount": "0"
                    },
                    {
                    "type": "FORM_OF_PAYMENT",
                    "amount": "6"
                    },
                    {
                    "type": "TICKETING",
                    "amount": "0"
                    }
                ],
                "additionalServices": [
                    {
                    "type": "CHECKED_BAGS",
                    "amount": "100"
                    },
                    {
                    "type": "SEATS",
                    "amount": "166"
                    }
                ]
                },
                "pricingOptions": {
                "fareType": [
                    "PUBLISHED"
                ],
                "includedCheckedBags": false
                },
                "validatingAirlineCodes": [
                "IB"
                ],
                "travelerPricings": [
                {
                    "travelerId": "1",
                    "fareOption": "STANDARD",
                    "travelerType": "ADULT",
                    "price": {
                        "currency": "EUR",
                        "total": "200.94",
                        "base": "126",
                        "taxes": [
                            {
                            "code": "YQ",
                            "amount": "0.94"
                            },
                            {
                            "code": "CJ",
                            "amount": "41.67"
                            },
                            {
                            "code": "FR",
                            "amount": "31.33"
                            }
                        ]
                    },
                    "fareDetailsBySegment": [
                        {
                            "segmentId": "1",
                            "cabin": "ECONOMY",
                            "fareBasis": "ANNNNF4K",
                            "brandedFare": "LIGHTONE",
                            "class": "A",
                            "isAllotment": true,
                            "allotmentDetails": {
                                "tourName": "tour",
                                "tourReference": "ref"
                            },
                            "sliceDiceIndicator": "ABCDEF",
                            "includedCheckedBags": {
                                "quantity": 0
                            }
                        },
                        {
                            "segmentId": "20",
                            "cabin": "ECONOMY",
                            "fareBasis": "ANNNNF4K",
                            "brandedFare": "LIGHTONE",
                            "class": "A",
                            "isAllotment": true,
                            "allotmentDetails": {
                            "tourName": "tour",
                            "tourReference": "ref"
                            },
                            "sliceDiceIndicator": "ABCDEF",
                            "includedCheckedBags": {
                            "quantity": 0
                            }
                        },
                        {
                            "segmentId": "30",
                            "cabin": "ECONOMY",
                            "fareBasis": "ANNNNF4K",
                            "brandedFare": "LIGHTONE",
                            "class": "A",
                            "isAllotment": true,
                            "allotmentDetails": {
                            "tourName": "tour",
                            "tourReference": "ref"
                            },
                            "sliceDiceIndicator": "ABCDEF",
                            "includedCheckedBags": {
                            "quantity": 0
                            }
                        },
                        {
                            "segmentId": "31",
                            "cabin": "ECONOMY",
                            "fareBasis": "ANNNNF4K",
                            "brandedFare": "LIGHTONE",
                            "class": "A",
                            "isAllotment": true,
                            "allotmentDetails": {
                            "tourName": "tour",
                            "tourReference": "ref"
                            },
                            "sliceDiceIndicator": "ABCDEF",
                            "includedCheckedBags": {
                            "quantity": 0
                            }
                        }
                    ]
                },
                {
                    "travelerId": "2",
                    "fareOption": "STANDARD",
                    "travelerType": "CHILD",
                    "price": {
                    "currency": "EUR",
                    "total": "180.94",
                    "base": "106",
                    "taxes": [
                        {
                        "code": "YQ",
                        "amount": "0.94"
                        },
                        {
                        "code": "CJ",
                        "amount": "41.67"
                        },
                        {
                        "code": "FR",
                        "amount": "31.33"
                        }
                    ]
                    },
                    "fareDetailsBySegment": [
                        {
                            "segmentId": "1",
                            "cabin": "ECONOMY",
                            "fareBasis": "ANNNNF4K",
                            "brandedFare": "LIGHTONE",
                            "class": "A",
                            "isAllotment": true,
                            "allotmentDetails": {
                            "tourName": "tour",
                            "tourReference": "ref"
                            },
                            "sliceDiceIndicator": "ABCDEF",
                            "includedCheckedBags": {
                            "quantity": 0
                            },
                            "additionalServices": {
                            "chargeableCheckedBags": {
                                "quantity": 1,
                                "weight": 20
                            },
                            "chargeableSeatNumber": "33D"
                            }
                        },
                        {
                            "segmentId": "20",
                            "cabin": "ECONOMY",
                            "fareBasis": "ANNNNF4K",
                            "brandedFare": "LIGHTONE",
                            "class": "A",
                            "isAllotment": true,
                            "allotmentDetails": {
                            "tourName": "tour",
                            "tourReference": "ref"
                            },
                            "sliceDiceIndicator": "ABCDEF",
                            "includedCheckedBags": {
                            "quantity": 0
                            },
                            "additionalServices": {
                            "chargeableCheckedBags": {
                                "quantity": 1,
                                "weight": 20
                            },
                            "chargeableSeatNumber": "28A"
                            }
                        },
                        {
                            "segmentId": "30",
                            "cabin": "ECONOMY",
                            "fareBasis": "ANNNNF4K",
                            "brandedFare": "LIGHTONE",
                            "class": "A",
                            "isAllotment": true,
                            "allotmentDetails": {
                            "tourName": "tour",
                            "tourReference": "ref"
                            },
                            "sliceDiceIndicator": "ABCDEF",
                            "includedCheckedBags": {
                            "quantity": 0
                            },
                            "additionalServices": {
                            "chargeableCheckedBags": {
                                "quantity": 1,
                                "weight": 20
                            },
                            "chargeableSeatNumber": "12C"
                            }
                        },
                        {
                            "segmentId": "31",
                            "cabin": "ECONOMY",
                            "fareBasis": "ANNNNF4K",
                            "brandedFare": "LIGHTONE",
                            "class": "A",
                            "isAllotment": true,
                            "allotmentDetails": {
                            "tourName": "tour",
                            "tourReference": "ref"
                            },
                            "sliceDiceIndicator": "ABCDEF",
                            "includedCheckedBags": {
                            "quantity": 0
                            },
                            "additionalServices": {
                            "chargeableCheckedBags": {
                                "quantity": 1,
                                "weight": 20
                            },
                            "chargeableSeatNumber": "33D"
                            }
                        }
                    ]
                },
                {
                    "travelerId": "3",
                    "fareOption": "STANDARD",
                    "travelerType": "HELD_INFANT",
                    "associatedAdultId": "1",
                    "price": {
                    "currency": "EUR",
                    "total": "41.33",
                    "base": "10",
                    "taxes": [
                        {
                        "code": "FR",
                        "amount": "31.33"
                        }
                    ]
                    },
                    "fareDetailsBySegment": [
                    {
                        "segmentId": "1",
                        "cabin": "ECONOMY",
                        "fareBasis": "ANNNNF4K",
                        "brandedFare": "LIGHTONE",
                        "class": "A",
                        "isAllotment": true,
                        "allotmentDetails": {
                        "tourName": "tour",
                        "tourReference": "ref"
                        },
                        "sliceDiceIndicator": "ABCDEF",
                        "includedCheckedBags": {
                        "quantity": 0
                        }
                    },
                    {
                        "segmentId": "20",
                        "cabin": "ECONOMY",
                        "fareBasis": "ANNNNF4K",
                        "brandedFare": "LIGHTONE",
                        "class": "A",
                        "isAllotment": true,
                        "allotmentDetails": {
                        "tourName": "tour",
                        "tourReference": "ref"
                        },
                        "sliceDiceIndicator": "ABCDEF",
                        "includedCheckedBags": {
                        "quantity": 0
                        }
                    },
                    {
                        "segmentId": "30",
                        "cabin": "ECONOMY",
                        "fareBasis": "ANNNNF4K",
                        "brandedFare": "LIGHTONE",
                        "class": "A",
                        "isAllotment": true,
                        "allotmentDetails": {
                        "tourName": "tour",
                        "tourReference": "ref"
                        },
                        "sliceDiceIndicator": "ABCDEF",
                        "includedCheckedBags": {
                        "quantity": 0
                        }
                    },
                    {
                        "segmentId": "31",
                        "cabin": "ECONOMY",
                        "fareBasis": "ANNNNF4K",
                        "brandedFare": "LIGHTONE",
                        "class": "A",
                        "isAllotment": true,
                        "allotmentDetails": {
                        "tourName": "tour",
                        "tourReference": "ref"
                        },
                        "sliceDiceIndicator": "ABCDEF",
                        "includedCheckedBags": {
                        "quantity": 0
                        }
                    }
                    ]
                }
                ]
            }
            ],
            "ticketingAggreement": {
            "option": "DELAY_TO_CANCEL",
            "dateTime": "2018-08-21T10:15:00.000"
            },
            "contacts": [
            {
                "companyName": "AMADEUS",
                "purpose": "STANDARD",
                "phones": [
                {
                    "deviceType": "FAX",
                    "countryCallingCode": "33",
                    "number": "480080070"
                },
                {
                    "deviceType": "LANDLINE",
                    "countryCallingCode": "33",
                    "number": "480080070"
                }
                ],
                "emailAddress": "support@mail.com",
                "address": {
                "lines": [
                    "485 route du Pin Montard"
                ],
                "postalCode": "06902",
                "cityName": "Sophia Antipolis Cedex",
                "countryCode": "FR"
                }
            }
            ]
        },
        "dictionaries": {
            "locations": {
            "CDG": {
                "cityCode": "PAR",
                "countryCode": "FR"
            },
            "ORY": {
                "cityCode": "PAR",
                "countryCode": "FR"
            },
            "MAD": {
                "cityCode": "MAD",
                "countryCode": "ES"
            }
            }
        }
    };
}